<template>
  <div style="margin-top: 20px">
    <Spinner :isLoading="isLoading" />
    <a ref="topSection" />

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">


        <b-card v-if="validationMessages.filter(f => f.messageType == 'ERROR').length > 0"
          class="uBind validationMessages"
          style="position: fixed; top: 10px; z-index: 5000; background-color: #ff4438 !important; left: calc(50% - 360px);">
          <h3>Validation messages</h3>
          <h4>Please review the following messages.</h4>

          <div v-for="(item, index) in validationMessages" :key="index"
            style="display: inline-flex; color: white; width: 100%;">
            <div style="flex-basis: 200px;">{{ item.messageType }}</div>
            <div style="flex-basis: 100%;">{{ item.text }}</div>
          </div>


        </b-card>

        <div
          v-if="isLoading == false && step != 'accepted' && step != 'outcome' && (isDeclined == false && model.vehicleRideShare != true && model.vehicleUsageSpecialFitOut != true && model.atFault != true && model.claimLodged != true && !(validationMessagesForCard.length > 0 || hasbeenReferred == true))"
          :style="'position: fixed;left: calc(50% + 330px);z-index:2000;top:4px;border: 2px solid ' + (isDeclined == true || apiErrors.length > 0 ? '#f4aaaa' : (validationMessagesForCard.length > 0 || hasbeenReferred == true ? 'orange' : 'green')) + ';color: #525f7f;background-color: white; border-radius: 10px; height: 50px;padding:11px 20px 10px 20px'">
          Estimated Premium: <span :class="{ premiumInvalid: isDeclined }">{{
            formatCurrencyString(parseFloat(model.Data_obj.totalPremiumIncFees))
          }}</span> </div>

        <!-- <base-header class="pb-6 bg-primary">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">PE LIVE</h6>
        </b-col>
      </b-row>
    </base-header> -->
        <div class="container-fluid mt--6" v-if="model != null && step == 'step1'">
          <!-- <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)"> -->


          <b-card no-body class="mb-4 uBind" v-if="((mode == 'view' || mode == 'edit') &&
            model.Customer_policy_status == 'in_progress') ||
            model.Customer_policy_status ==
            'offer_sent_awaiting_information' ||
            model.Customer_policy_status == 'offer_accepted'
          ">
            <b-card-header>
              <h2 class="secondary-card-header">
                Quote Details
              </h2>

              <!-- <h3 class="mb-0">Premium</h3> -->
            </b-card-header>
            <b-card-body>

              <b-row>
                <b-col md="3">
                  <!-- <base-input name="Insured Name" label="Business Name" inputGroupClasses="uBind-input"
                  :rules="formRules.insuredName">
                  <el-select id="insuredDD" @blur="InsuredNameBlurred($event)" @visible-change="visibleChange($event)"
                    @keyup.native="setInsuredName($event)" @change="selectCustomer($event)" v-model="model.insuredName"
                    :disabled="fieldsDisabled.insuredName" :rules="formRules.insuredName" filterable
                    placeholder="Add or search previous customers" v-cancel-read-only>
                    <el-option class="style-dropdown" v-for="(option, index) in customerList" :key="index"
                      :label="option.Customer_insured_name + ' (' + option.Customer_contact_first_name + ' ' + option.Customer_contact_last_name + ')'"
                      :value="option.Customer_id">
                    </el-option>
                  </el-select>
                </base-input> -->

                  <base-input type="text" name="Quote" label="Quote Ref" v-model="model.Quote_Ref_No"
                    :disabled="fieldsDisabled.Quote_Ref_No" :rules="formRules.Quote_Ref_No"
                    inputGroupClasses="uBind-input" />

                </b-col>
                <b-col md="3">
                  <base-input type="date" name="Quote" label="Quote Date" v-model="model.quote_created_date" disabled
                    :rules="formRules.insuredName" inputGroupClasses="uBind-input" />

                </b-col>
                <b-col md="3">
                  <base-input name="Inception Date" type="date" label="Inception Date" :rules="formRules.policyStart"
                    disabled v-model="model.policyStart" />
                </b-col>

                <b-col md="3">
                  <base-input name="Expiry Date" type="date" disabled label="Expiry Date" :rules="formRules.expiryDate"
                    v-model="model.expiryDate" />
                </b-col>
              </b-row>

              <b-card style="margin-left:-15px;margin-right:-15px; padding:10px;">

                <b-row>
                  <b-col md="9">
                    <h3>
                      Vehicles
                    </h3>
                  </b-col>
                  <b-col md="3" style="text-align: right;">
                    <base-button @click="addVehicle()" type="danger" class="mb-4 bg-danger">Add Vehicle</base-button>
                  </b-col>
                </b-row>

                <b-row v-if="checkedVehicleDetails != true" class="mb-3">
                  <b-col cols="12">
                    <div class="vehicle-details-hint">
                      Please click the edit buttons
                      <img
                        class="vehicle-details-hint-icon"
                        src="data:image/png;base64,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"
                        alt="edit"
                      />
                      below for each of your vehicles to ensure your No Claim Bonus (NCB), all vehicle details and Radius of Operation information, is correct.
                    </div>
                  </b-col>
                </b-row>

                <b-row style="font-size: 9pt; font-weight: bold; padding: 3px 0px 6px 0px; text-decoration: underline;">
                  <b-col class="less-padding vehicleHeaderText" style="flex-basis: 13%;">
                    Vehicle Type
                  </b-col>


                  <b-col class="less-padding vehicleHeaderText" style="flex-basis: 13%;">
                    Freight Task
                  </b-col>

                  <b-col class="less-padding vehicleHeaderText"
                    style="flex-basis: 6%; word-break: normal; overflow-wrap: normal;">
                    VIN / Registration

                  </b-col>

                  <!-- <b-col class="less-padding vehicleHeaderText" style="flex-basis: 5%;">
                    Registration

                  </b-col> -->

                  <b-col class="less-padding vehicleHeaderText" style="flex-basis: 5%;">
                    Year

                  </b-col>

                  <b-col class="less-padding vehicleHeaderText" style="flex-basis: 5%;">
                    Make

                  </b-col>
                  <b-col class="less-padding vehicleHeaderText" style="flex-basis: 5%;">
                    Model
                  </b-col>

                  <b-col class="less-padding vehicleHeaderText" style="flex-basis: 5%;">
                    Sum Insured

                  </b-col>

                  <b-col class="less-padding vehicleHeaderText" style="flex-basis: 7%;">
                    Sum Insured Type
                  </b-col>

                  <b-col class="less-padding vehicleHeaderText" style="flex-basis: 5%;">
                    Excess
                  </b-col>
                  <!-- <b-col style="flex-basis: 5%;">
                    <base-input label="State" v-model="item.vehicle.vehicleState" inputGroupClasses="uBind-input" />

                  </b-col> -->
                  <b-col class="less-padding" style="flex-basis: 3%;">
                    Post Code

                  </b-col>
                  <b-col class="less-padding" style="flex-basis: 10px; align-content: center">

                  </b-col>


                </b-row>

                <b-row v-for="(item, index) in model.vehicles" :key="index" style="padding: 3px 0px 3px 0px;">

                  <b-col class="less-padding" style="flex-basis: 13%;">
                    <!-- <base-input name="Vehicle Type" :rules="formRules.vehicleType" inputGroupClasses="uBind-input">
                      <el-select v-model="item.vehicle.vehicleType" :disabled="fieldsDisabled.vehicleType">
                        <el-option v-for="option in vehicleTypeOptions" :key="option.label" :label="option.label"
                          :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input> -->

                    <div class="vehicleText">{{vehicleTypeOptions.find(f => f.value == item.vehicle.vehicleType).label}}
                    </div>
                  </b-col>


                  <b-col class="less-padding" style="flex-basis: 13%;">

                    <div class="vehicleText">{{freightTaskOptions.find(f => f.value == item.vehicle.freightTask).label}}
                    </div>

                    <!-- <base-input name="Freight Task" :rules="formRules.freightTask" inputGroupClasses="uBind-input">
                      <el-select v-model="item.vehicle.freightTask" :disabled="fieldsDisabled.freightTask">
                        <el-option v-for="option in freightTaskOptions" :key="option.label" :label="option.label"
                          :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input> -->
                  </b-col>

                  <b-col class="less-padding" style="flex-basis: 6%;">

                    <div class="vehicleText">{{ item.vehicle.motorwebGlasses.vin }} {{
                      item.vehicle.motorwebGlasses.registration }}</div>

                  </b-col>

                  <!-- <b-col class="less-padding" style="flex-basis: 5%;">
                    <div class="vehicleText">{{ item.vehicle.motorwebGlasses.registration }}</div>

                  </b-col> -->

                  <b-col class="less-padding" style="flex-basis: 5%;">
                    <!-- <base-input v-model="item.vehicle.vehicleYear" inputGroupClasses="uBind-input" /> -->

                    <div class="vehicleText">{{ item.vehicle.vehicleYear }}</div>

                  </b-col>

                  <b-col class="less-padding" style="flex-basis: 5%;">
                    <!-- <base-input v-if="item.vehicle.vehicleType != 'SE1'" v-model="item.vehicle.motorwebGlasses.make"
                      inputGroupClasses="uBind-input" /> -->

                    <div class="vehicleText">{{ item.vehicle.motorwebGlasses.make }}</div>

                    <!-- <base-input v-if="item.vehicle.vehicleType == 'SE1'" name="Make" :rules="formRules.insuredState"
                      inputGroupClasses="uBind-input">
                      <el-select @change="item.vehicle.motorwebGlasses.family = ''"
                        v-model="item.vehicle.motorwebGlasses.make">
                        <el-option v-for="option in carModels" :key="option.Make" :label="option.Make"
                          :value="option.Make">
                        </el-option>
                      </el-select></base-input> -->




                  </b-col>
                  <b-col class="less-padding" style="flex-basis: 5%;">
                    <!-- <base-input name="Model" label="Model" :rules="formRules.insuredState"
                      inputGroupClasses="uBind-input">
                      <el-select v-model="item.model">
                        <el-option v-for="option in vehicleModelOptions" :key="option.label" :label="option.label"
                          :value="option.value">
                        </el-option>
                      </el-select></base-input> -->

                    <div class="vehicleText">{{ item.vehicle.motorwebGlasses.family }}</div>

                    <!-- <base-input v-if="item.vehicle.vehicleType == 'SE1'" name="Family" :rules="formRules.insuredState"
                      inputGroupClasses="uBind-input">
                      <el-select v-model="item.vehicle.motorwebGlasses.family">
                        <el-option
                          v-for="option in (carModels.find(f => f.Make == item.vehicle.motorwebGlasses.make) ? carModels.find(f => f.Make == item.vehicle.motorwebGlasses.make).Models : [])"
                          :key="option" :label="option" :value="option">
                        </el-option>
                      </el-select></base-input> -->



                    <!-- <base-input v-if="item.vehicle.vehicleType != 'SE1'" v-model="item.vehicle.motorwebGlasses.family"
                      inputGroupClasses="uBind-input" /> -->


                  </b-col>

                  <b-col class="less-padding" style="flex-basis: 5%;">
                    <!-- <base-input v-model="item.vehicle.sumInsured" inputGroupClasses="uBind-input" /> -->

                    <div class="vehicleText">{{ formatCurrencyStringNoDecimals(parseFloat(item.vehicle.sumInsured)) }}
                    </div>

                  </b-col>

                  <b-col class="less-padding" style="flex-basis: 7%;">
                    <div class="vehicleText">{{ getSumInsuredTypeLabel(item.vehicle.sumInsuredType) }}</div>
                  </b-col>

                  <b-col class="less-padding" style="flex-basis: 5%;">
                    <div class="vehicleText">{{ formatCurrencyStringNoDecimals(parseFloat(item.vehicle.basicExcess)) }}
                    </div>

                  </b-col>
                  <!-- <b-col style="flex-basis: 5%;">
                    <base-input label="State" v-model="item.vehicle.vehicleState" inputGroupClasses="uBind-input" />

                  </b-col> -->
                  <b-col class="less-padding" style="flex-basis: 3%;">
                    <!-- <base-input v-model="item.vehicle.vehiclePostcode" inputGroupClasses="uBind-input" /> -->

                    <div class="vehicleText">{{ item.vehicle.vehiclePostcode }}</div>

                  </b-col>
                  <b-col class="less-padding"
                    style="align-content: center;flex-basis: 10px; padding: 0px; display: flex">
                    <base-button style="padding: 0px 5px 5px 5px; max-height: 30px;" class="bg-danger" type="danger"
                      icon @click="editVehicle(item, index)">
                      <b-icon font-scale="0.9" icon="pencil-square"></b-icon></base-button>
                    <base-button v-if="canRemoveVehicle(item)"
                      style="padding: 0px 5px 5px 5px;color: red; max-height: 30px;" class="bg-white" type="danger"
                      @click="removeVehicle(index)">
                      <b-icon font-scale="0.9" icon="trash"></b-icon></base-button>
                  </b-col>

                  <!-- <b-col md="4">

                <base-input name="State" label="State" :rules="formRules.insuredState" inputGroupClasses="uBind-input">
                  <el-select v-model="model.insuredState" :disabled="fieldsDisabled.insuredState">
                    <el-option v-for="option in states" :key="option.label" :label="option.label" :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>
              <b-col md="4">
                <base-input autocomplete="off" label="Postcode" type="number" v-model="model.insuredPostcode"
                  :disabled="fieldsDisabled.insuredPostcode" inputGroupClasses="uBind-input" />
              </b-col> -->
                </b-row>

                <b-row class="my-4">
                  <b-col cols="12" class="vehicle-details-confirm-col">
                    <div class="vehicle-details-confirm">
                      <base-input :rules="{ required: { allowFalse: false } }" name="above">
                        <label class="vehicle-details-confirm-check">
                          <input type="checkbox" v-model="checkedVehicleDetails" />
                          <span>I have confirmed the above vehicle details, NCB and operation details are correct.</span>
                        </label>
                      </base-input>
                    </div>
                  </b-col>
                </b-row>

              </b-card>


              <b-row>
                <b-col md="4">
                  <!-- <base-input prepend-icon="fas fa-dollar-sign" v-model="model.totalValue" name="Equipment Value"
                    label="Equipment Value" @keyup="quoteChanged()" /> -->
                </b-col>
                <b-col md="4">
                  <!-- <base-input prepend-icon="fas fa-dollar-sign" readonly v-model="model.totalExcess" name="Excess"
                    label="Excess" /> -->
                  <!-- <base-input name="excesses" label="Excess">
                    <el-select id="excessDD" @change="quoteChanged()" v-model="model.totalExcess" filterable>
                      <el-option v-for="option in excessOptions" :key="option.value" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input> -->
                </b-col>
                <b-col md="4">
                  <base-input type="read-only-price" prepend-icon="fas fa-dollar-sign" readonly
                    v-model="model.Data_obj.totalPremiumIncFees" name="Total Insurance Premium"
                    label="Total Insurance Premium (inc all fees and charges)" />
                </b-col>
              </b-row>



              <!-- <b-row>
                <b-col md="12" style="text-align: center;">
                  <base-button @click="refreshQuote()" type="danger" class="mb-4 bg-danger">Get New
                    Premium</base-button>
                </b-col>
              </b-row> -->


              <!-- <b-row>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium" prepend-icon="fas fa-dollar-sign" readonly
                    name="Insurance Premium" label="Insurance Premium" />
                </b-col>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium_gst" prepend-icon="fas fa-dollar-sign"
                    readonly name="Premium GST" label="Premium GST" />
                </b-col>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium_stamp_duty"
                    prepend-icon="fas fa-dollar-sign" readonly name="Stamp Duty" label="Stamp Duty" />
                </b-col>
                <b-col md="3">
                  <base-input v-model="model.Customer_policy_fee" prepend-icon="fas fa-dollar-sign" readonly
                    name="Policy Fee" label="Policy Fee" />
                </b-col> 
              </b-row> -->
              <!-- <b-row>
                <b-col md="12">
                  <h5 style="font-size: 11pt !important">Notes:</h5>
                  <div style="margin-bottom: 25px">
                    <ul style="font-size: 11px;margin-bottom: 5px;" v-for="(option, index) in quoteNotes" :key="index">
                      <li style="font-size: 11px;margin-bottom: 5px;">{{ option }}</li>
                    </ul>
                  </div>
                </b-col>
              </b-row> -->
              <!-- <div class="text-center" v-if="mode == 'view' &&
                model.Customer_policy_status == 'in_progress'
                ">
                <b-row align-v="center">
                  <b-col>
                    <base-button @click="emailOffer()" type="danger" class="mb-4 bg-danger">Send to Customer</base-button>
                  </b-col>
                </b-row>
              </div> -->
              <div class="text-center" v-if="model.Customer_policy_status ==
                'offer_sent_awaiting_information'
              ">
                <b-row align-v="center">
                  <b-col>
                    <base-button @click="emailOffer()" type="danger" class="mb-4 bg-danger">Resend Customer Insurance
                      Offer</base-button>
                  </b-col>
                </b-row>
              </div>
            </b-card-body>
          </b-card>




          <b-card no-body class="uBind">
            <b-card-header>
              <h2 class="secondary-card-header">
                Insured Details
              </h2>
            </b-card-header>

            <b-card-body>

              <b-row>
                <b-col md="6">
                  <!-- <base-input name="Insured Name" label="Business Name" inputGroupClasses="uBind-input"
                  :rules="formRules.insuredName">
                  <el-select id="insuredDD" @blur="InsuredNameBlurred($event)" @visible-change="visibleChange($event)"
                    @keyup.native="setInsuredName($event)" @change="selectCustomer($event)" v-model="model.insuredName"
                    :disabled="fieldsDisabled.insuredName" :rules="formRules.insuredName" filterable
                    placeholder="Add or search previous customers" v-cancel-read-only>
                    <el-option class="style-dropdown" v-for="(option, index) in customerList" :key="index"
                      :label="option.Customer_insured_name + ' (' + option.Customer_contact_first_name + ' ' + option.Customer_contact_last_name + ')'"
                      :value="option.Customer_id">
                    </el-option>
                  </el-select>
                </base-input> -->

                  <base-input type="text" name="Insured Name" label="Business Name"
                    v-model="model.Customer_insured_name" :disabled="fieldsDisabled.insuredName"
                    :rules="formRules.insuredName" inputGroupClasses="uBind-input" />

                </b-col>
                <b-col md="6"> </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <!-- <div>
                    <a class="abn-link" target="_blank" href="https://abr.business.gov.au/">Don't know the ABN?</a>
                  </div> -->
                  <base-input type="text" name="Insured ABN" label="Insured ABN" pattern="[0-9]{11}"
                    v-model="model.Customer_abn" :disabled="fieldsDisabled.insuredABN" :rules="formRules.insuredABN"
                    prependIcon="fas fa-certificate" inputGroupClasses="uBind-input" />
                </b-col>
                <b-col md="6">
                  <!-- <base-input label="Please describe the main Business activities"
                    placeholder="E.g. Excavation services" v-model="model.Customer_business_description"
                    :disabled="fieldsDisabled.businessDesc" inputGroupClasses="uBind-input" /> -->

                  <base-input name="Business Description" label="Business Description" inputGroupClasses="uBind-input"
                    :rules="formRules.equipmentDescription">
                    <el-select @change="refreshQuote" v-model="model.businessDesc">
                      <el-option v-for="option in businessDescriptionsOptions" :key="option.value"
                        :label="replaceAmp(option.label)" :value="option.value">
                      </el-option>
                    </el-select>

                  </base-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <base-input inputGroupClasses="uBind-input" name="Contact First Name" label="Contact First Name"
                    :rules="formRules.contactFName" v-model="model.Customer_contact_first_name"
                    :disabled="fieldsDisabled.contactFName" placeholder="John" />
                </b-col>
                <b-col md="6">
                  <base-input inputGroupClasses="uBind-input" name="Contact Last Name" label="Contact Last Name"
                    :rules="formRules.contactLName" v-model="model.Customer_contact_last_name"
                    :disabled="fieldsDisabled.contactLName" placeholder="Smith" />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <base-input inputGroupClasses="uBind-input" label="Contact Phone Number" name="Contact Phone Number"
                    :rules="formRules.contactPhone" v-model="model.Customer_contact_number"
                    :disabled="fieldsDisabled.contactPhone" />
                </b-col>
                <b-col md="6">
                  <base-input inputGroupClasses="uBind-input" name="Contact Email" label="Contact Email"
                    :rules="formRules.contactEmail" v-model="model.Customer_contact_email"
                    :disabled="fieldsDisabled.contactEmail" placeholder="john@example.com" />
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12" class="mb-4 uBind-input">
                  <label for="addrs_1" class="form-control-label">
                    Search Insured Address
                  </label>
                  <input autocomplete="new-password" style="cursor: text" @blur="clearAddressFields"
                    class="form-control" id="addrs_1" v-model="model.Customer_contact_street"
                    :disabled="fieldsDisabled.insuredStreet" :rules="formRules.insuredStreet" />
                </b-col>
              </b-row>

              <b-row>
                <b-col md="4">
                  <base-input label="City" v-model="model.Customer_contact_city" :disabled="fieldsDisabled.insuredCity"
                    :rules="formRules.insuredCity" inputGroupClasses="uBind-input" />
                </b-col>
                <b-col md="4">
                  <!-- <base-input label="State" v-model="model.insuredState" /> -->
                  <base-input name="State" label="State" :rules="formRules.insuredState"
                    inputGroupClasses="uBind-input">
                    <el-select v-model="model.Customer_state" :disabled="fieldsDisabled.insuredState">
                      <el-option v-for="option in states" :key="option.label" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input autocomplete="off" label="Postcode" type="number" v-model="model.Customer_postcode"
                    :disabled="fieldsDisabled.insuredPostcode" inputGroupClasses="uBind-input" />
                </b-col>
              </b-row>

            </b-card-body>

          </b-card>



          <b-card no-body class="uBind mb-4">
            <b-card-header class="mb-0">
              <h3 class="secondary-card-header">
                Business Operations
              </h3>

              <h4>
                Please enter the information below.
              </h4>
            </b-card-header>

            <b-card-body>

              <b-row>
                <b-col md="6">
                  <base-input name="Wh" label="What are the Primary Goods carried or the usage of your Vehicle/s?"
                    :rules="formRules.primaryGoods" inputGroupClasses="uBind-input">
                    <el-select @change="refreshQuote" v-model="model.primaryGoods"
                      :disabled="fieldsDisabled.primaryGoods">
                      <el-option v-for="option in primaryGoodsOptions" :key="option.label" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>

                  </base-input>
                  <div class="primary-goods-hint">
                    *Please ensure you are selecting the correct category
                  </div>
                </b-col>

                <b-col md="6">
                  <base-input name="Time in business"
                    label="How long has the client or business entity named been operating, either as a sole trader or business?"
                    :rules="formRules.primaryGoods" inputGroupClasses="uBind-input">
                    <el-select @change="updateTimeInBusines" v-model="model.lengthOfOperating"
                      :disabled="fieldsDisabled.primaryGoods">
                      <el-option v-for="option in timeInBusinessOptions" :key="option.label" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>

                  </base-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <base-input name="Additional Goods"
                    label="Do you carry any other Goods? If so, please add them below."
                    inputGroupClasses="uBind-input">
                    <el-select @change="refreshQuote" v-model="model.additionalGoods" multiple filterable
                      placeholder="Select additional goods (if any)" :disabled="fieldsDisabled.primaryGoods">
                      <el-option v-for="option in primaryGoodsOtherOptions" :key="option.value" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>

          <b-card no-body class="uBind mb-4">
            <b-card-body>

              <b-row>
                <b-col md="6">
                  <h3>
                    Principal Situation/Depot
                  </h3>
                </b-col>

                <b-col md="6" style="text-align: right;">
                  <base-button @click="copyAddress()" type="danger" class="mb-4 bg-danger">Copy from Insured
                    Address</base-button>
                </b-col>

              </b-row>

              <b-row>
                <b-col md="12" class="mb-4 uBind-input">
                  <label for="addrs_2" class="form-control-label">
                    Search Address
                  </label>
                  <input autocomplete="new-password" style="cursor: text" @blur="clearAddressFields"
                    class="form-control" id="addrs_2" v-model="model.situationStreet"
                    :disabled="fieldsDisabled.situationStreet" :rules="formRules.situationStreet" />
                </b-col>
              </b-row>

              <b-row>
                <b-col md="4">
                  <base-input label="City" v-model="model.situationCity" :disabled="fieldsDisabled.situationCity"
                    :rules="formRules.situationCity" inputGroupClasses="uBind-input" />
                </b-col>
                <b-col md="4">

                  <base-input name="State" label="State" :rules="formRules.situationState"
                    inputGroupClasses="uBind-input">
                    <el-select v-model="model.situationState" :disabled="fieldsDisabled.situationState">
                      <el-option v-for="option in states" :key="option.label" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input autocomplete="off" label="Postcode" type="number" v-model="model.situationPostcode"
                    :disabled="fieldsDisabled.situationPostcode" inputGroupClasses="uBind-input" />
                </b-col>
              </b-row>

              <b-row>
                <b-col md="10" class="answerText">
                  Are you entitled to claim NSW Small business Stamp Duty Exemption on Commercial Motor Vehicle
                  insurance for NSW registered vehicles?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="NSW Stamp Duty Exemption">
                    <base-switch @change="refreshQuote" on-text="Yes" off-text="No" v-model="model.nswSdExemption">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row v-if="model.nswSdExemption == true">
                <b-col md="12" class="answerText" style="padding-left: 50px;">
                  <base-input :rules="{ required: { allowFalse: false } }" name="NSW SD Exemption Declaration">
                    <b-form-checkbox v-model="nswSdExemptionDeclaration" style="height: 100px">
                      <span>I confirm that I <a target="_blank"
                          href="https://www.revenue.nsw.gov.au/taxes-duties-levies-royalties/insurance-duty/small-business-exemption">qualify
                          as a CGT small business</a>, and that I have attached a valid NSW Small Business Stamp Duty
                        Exemption Declaration and that it is complete and correct. I acknowledge that false or
                        misleading information provided to obtain the small business exemptions carries penalties, as
                        outlined by NSW Revenue, and that We may, to execute our obligations, require you to pay or
                        reimburse Us the duty, together with any interest or penalty tax.
                      </span>
                    </b-form-checkbox>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <base-input name="Radius of Operation" label="Radius of Operation" :rules="formRules.situationState"
                    inputGroupClasses="uBind-input">
                    <el-select @change="refreshQuote" v-model="model.radiusOfOperation"
                      :disabled="fieldsDisabled.primaryGoods">
                      <el-option v-for="option in radiusOfOperation" :key="option.label" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
              </b-row>

              <b-row class="mt-3 mb-2">
                <b-col md="12">
                  <h3 class="secondary-card-header mb-0">
                    Vehicle Details
                  </h3>
                  <h4 class="mt-2">
                    Please enter the information below.
                  </h4>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Are all of the vehicles being included on this quotation currently insured?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice1">
                    <base-switch on-text="Yes" off-text="No" v-model="model.currentlyInsured">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row v-if="model != null && model.currentlyInsured == false">

                <b-col md="12">

                  <base-input name="Reason not insured"
                    label="What is the reason vehicle(s) on this quotation are currently uninsured?"
                    :rules="formRules.situationState" inputGroupClasses="uBind-input">
                    <el-select @change="refreshQuote" v-model="model.reasonNotInsured"
                      :disabled="fieldsDisabled.primaryGoods">
                      <el-option v-for="option in reasonsNotInsured" :key="option.label" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>

              </b-row>

              <b-row v-if="model != null && model.currentlyInsured == true">

                <b-col md="12">

                  <base-input name="Current Insurer" label="Who is the current insurer for these vehicles?"
                    :rules="formRules.situationState" inputGroupClasses="uBind-input">
                    <el-select @change="refreshQuote" v-model="model.currentInsurer"
                      :disabled="fieldsDisabled.primaryGoods">
                      <el-option v-for="option in currentInsurers" :key="option.label" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>

              </b-row>


              <!-- NSW SD exemption moved above Radius of Operation -->

              <!-- <b-row>
                <b-col md="6">

                  <base-input name="RegisteredGST" label="Registered for GST?">
                    <base-switch on-text="Yes" off-text="No" v-model="model.registeredForGST">
                    </base-switch>
                  </base-input>

                </b-col>

              </b-row> -->
              <!-- <b-row>
                <b-col md="6">
                  <base-input name="MoreThan50k"
                    label="Are there any of the items you are quoting worth more than $50,000 each?">
                    <base-switch on-text="Yes" off-text="No" v-model="model.moreThan50k">
                    </base-switch>
                  </base-input>
                </b-col>

              </b-row> -->

              <!-- <base-button @click="createNewQuote()" type="danger" class="mb-4 bg-danger">Create Quote</base-button> -->




              <!-- </b-card-body>
          </b-card> -->

              <!-- <b-card class="uBind"> -->
              <!-- <b-row>
              <h2 class="secondary-card-header">
                Description of Asset
              </h2>
            </b-row> -->


              <!-- <b-row style="margin-bottom: 10px;">
              <div class="infoText">It is important that the asset is described correctly on the insurance policy. If it
                is not declared correctly and or attachments are missing, you may not be insured correctly.</div>

              <div class="infoText">Please provide a description of the asset in the field below or upload a dealers
                quotation or invoice outlining a description of the asset. </div>

            </b-row> -->



              <b-row style="margin-bottom: 20px">
                <b-col md="6">
                  <div class="example-btn">
                    <ul>
                      <li v-for="(file, index) in fileList" :key="uploaderKey + '_file_' + index">
                        <div style="display: inline-block">{{ file.name }}</div>
                        <div v-if="!file.success" style="display: inline-block; font-weight: bold; padding-left: 10px">
                          Please wait...file processing
                        </div>
                        <div v-if="file.success" style="display: inline-block; font-weight: bold; padding-left: 10px">
                          Upload successful
                        </div>
                      </li>
                    </ul>
                    <div
                      style="display: block; font-weight: 600;font-size: 0.875rem; color: #525f7f; margin-bottom: 20px">
                      Please upload invoice if available
                    </div>
                    <file-upload class="btn btn-primary btn-uploader" :custom-action="customAction"
                      extensions="gif,jpg,jpeg,png,webp,doc,docx,pdf,xls,xlsx,csv"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/msword,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      multiple v-model="fileList" @input-filter="inputFilter" @input-file="inputFile"
                      :input-id="uploaderKey" :ref="uploaderKey" active="true">
                      <i class="fa fa-plus"></i>
                      Select files
                    </file-upload>
                  </div>

                </b-col>
              </b-row>




              <!-- <b-row>

              <b-col md="12">

                <div style="display: block; font-weight: 600;font-size: 0.875rem; color: #525f7f; margin-bottom: 20px">
                  -- Or --
                </div>
                <base-input ref="descriptionOfAsset" name="Description of Asset" label="Description of Asset"
                  inputGroupClasses="uBind-input">
                  <textarea v-model="model.descriptionOfAsset" class="form-control" rows="4"></textarea>
                </base-input>
              </b-col>
            </b-row> -->

              <b-row>
                <b-col md="6">

                  <base-input name="Financier" label="Financier" rules="required">
                    <el-select id="financierDD" @change="readFinancier($event)" v-model="model.financier" filterable>
                      <el-option v-for="option in financiers" :key="option.label" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="6">
                  <base-input id="financierOther" v-bind:disabled="model.financier != 'Other'"
                    placeholder="Select 'Other' in dropdown to activate this field" name="Financier - Other"
                    label="Financier - Other" v-model="model.financierOther" />
                </b-col>
              </b-row>



              <!-- <div v-if="!(fileList.length > 0 || model.descriptionOfAsset)" class="invalid-feedback"
              style="display: block;">
              Please enter a description of the asset to be insured - or - upload a quote/invoice. </div> -->


              <div v-if="!model.financier" class="invalid-feedback" style="display: block;">
                Please select a Financier. </div>

              <div v-if="model.financier == 'Other' && (!model.financierOther || model.financierOther == '')"
                class="invalid-feedback" style="display: block;">
                Please enter a value for Financier / Other. </div>

            </b-card-body>
          </b-card>


          <b-card class="uBind" v-if="model.Data_obj.totalSumInsured > 125000">
            <b-row>
              <h2 class="secondary-card-header">
                Security Questions
              </h2>
            </b-row>


            <b-row style="margin-bottom: 30px;">
              Only for items of sum insured $125K or higher
            </b-row>

            <b-row style="height: 120px">
              <b-col md="6">
                <!-- <base-input name="security1" label="Where is the insured asset stored overnight?"
                  inputGroupClasses="uBind-input">
                  <el-select v-model="model.security1">
                    <el-option label="On the street" value="On the street" />
                    <el-option label="Garage" value="Garage" />
                    <el-option label="Carport" value="Carport" />
                    <el-option label="Driveway of property" value="Driveway of property" />
                    <el-option label="Other" value="other" />
                  </el-select>
                </base-input> -->
                <label class="form-control-label"> Where is the insured asset stored overnight? </label>
                <VueMultiselectComponent v-model="selectedSecurity1" :options="security1options" />
                <!-- <div v-if="selectedSecurity1.length == 0" class="invalid-feedback" style="display: block;"> Please select
                  at least one item </div> -->
              </b-col>
              <b-col md="6" v-if="selectedSecurity1.includes('Other')">
                <base-input inputGroupClasses="uBind-input" name="security1_other" label="Other (please specify)"
                  v-model="security1_other" />
                <div v-if="!security1_other || security1_other == ''" class="invalid-feedback" style="display: block;">
                  This field is required </div>
              </b-col>
            </b-row>



            <b-row style="height: 120px">
              <b-col md="6">
                <!-- <base-input name="security2"
                  label="What security mitigations measures are in place where the item is insured?"
                  inputGroupClasses="uBind-input">
                  <el-select v-model="model.security2">
                    <el-option label="Locked Shed" value="Locked Shed" />
                    <el-option label="Locked Trailer" value="Locked Trailer" />
                    <el-option label="Back to Base Alarm" value="Back to Base Alarm" />
                    <el-option label="24 hour tracking device" value="24 hour tracking device" />
                    <el-option label="Wheel lock nuts" value="Wheel lock nuts" />
                    <el-option label="Immoboliser" value="Immoboliser" />
                    <el-option label="Microdotting" value="Microdotting" />
                    <el-option label="Other" value="other" />
                  </el-select>
                </base-input> -->

                <label class="form-control-label"> What security mitigations measures are in place where the item is
                  insured? </label>
                <VueMultiselectComponent v-model="selectedSecurity2" :options="security2options" />

                <!-- <div v-if="selectedSecurity2.length == 0" class="invalid-feedback" style="display: block;"> Please select
                  at least one item </div> -->
              </b-col>
              <b-col md="6" v-if="selectedSecurity2.includes('Other')">
                <base-input inputGroupClasses="uBind-input" name="security2_other" label="Other (please specify)"
                  v-model="security2_other" />
                <div v-if="!security2_other || security2_other == ''" class="invalid-feedback" style="display: block;">
                  This field is required </div>
              </b-col>
            </b-row>

            <b-row style="height: 120px">
              <b-col md="6">
                <base-input inputGroupClasses="uBind-input" name="security3"
                  label="How long will this asset be stored on job sites at any one time?" v-model="security3" />
                <!-- <div v-if="!security3 || security3 == ''" class="invalid-feedback" style="display: block;">
                  This field is required </div> -->
              </b-col>

            </b-row>

            <b-row style="height: 120px">
              <b-col md="6">
                <!-- <base-input name="security4"
                  label="What security mitigation measures are in place whilst on the job site? Example, locked shed, locked trailer, secure compound."
                  inputGroupClasses="uBind-input">
                  <el-select v-model="model.security4">
                    <el-option label="Locked Shed" value="Locked Shed" />
                    <el-option label="Locked Trailer" value="Locked Trailer" />
                    <el-option label="Secure Compound" value="Secure Compound" />
                    <el-option label="Back to base alarm" value="Back to base alarm" />
                    <el-option label="24 hour tracking device" value="24 hour tracking device" />
                    <el-option label="Wheel lock nuts" value="Wheel lock nuts" />
                    <el-option label="Immoboliser" value="Immoboliser" />
                    <el-option label="Microdotting" value="Microdotting" />
                    <el-option label="Other" value="other" />
                  </el-select>
                </base-input> -->

                <label class="form-control-label"> What security mitigation measures are in place whilst on the job
                  site?
                </label>
                <VueMultiselectComponent v-model="selectedSecurity4" :options="security4options" />
                <!-- <div v-if="selectedSecurity4.length == 0" class="invalid-feedback" style="display: block;"> Please select
                  at least one item </div> -->
              </b-col>
              <b-col md="6" v-if="selectedSecurity4.includes('Other')">
                <base-input inputGroupClasses="uBind-input" name="security4_other" label="Other (please specify)"
                  v-model="security4_other" />
                <div v-if="!security4_other || security4_other == ''" class="invalid-feedback" style="display: block;">
                  This field is required </div>
              </b-col>
            </b-row>

          </b-card>

          <b-card class="uBind">

            <b-row v-if="checkedVehicleDetails == false">
              <b-col md="12" style="margin-bottom: 20px;margin-top:0px; text-align: center;">

                <div class="invalid-feedback" style="display: block; font-size: 12pt; font-weight: bold;">
                  Please confirm the vehicle details are correct at top of page. </div>
              </b-col>
            </b-row>



            <b-row>





              <b-col md="12" style="margin-bottom: 20px;margin-top:0px; text-align: center;">
                <div style="max-width: 600px; margin: auto; margin-bottom: 20px" class="infoText">Please confirm all the
                  details above are correct and proceed to next section.</div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" style="text-align: center;">


                <base-button v-bind:disabled="!isPage1FormValid() || filesUploading" @click="confirm('step2')"
                  type="danger" class="mb-4 bg-danger">Proceed to Driving and Claims History</base-button>
              </b-col>
            </b-row>
          </b-card>

          <!-- <div class="text-center">
            <b-row align-v="center" v-if="formMode == 'create'">
              <b-col>
                <base-button :disabled="!isFormValid" @click="createNewQuote()" type="danger" class="mb-4 bg-danger">Get
                  Premium</base-button>
              </b-col>
            </b-row>
            <div v-if="model.Customer_policy_status == 'in_progress' ||
              brokerObj.Broker_super_admin
              ">
              <b-row align-v="center" v-if="formMode == 'view'">
                <b-col>
                  <base-button @click="editQuote()" type="danger" class="mb-4 bg-danger">Edit Quote</base-button>
                </b-col>
              </b-row>

              <b-row align-v="center" v-if="formMode == 'edit'">
                <b-col>
                  <base-button @click="updateQuote()" type="danger" class="mb-4 bg-danger">Update Quote</base-button>
                </b-col>
              </b-row>
            </div>
          </div> -->

          <a ref="calcSection" />


        </div>
        <div class="container-fluid mt--6" style="margin-top: -7.5rem !important"
          v-if="model != null && step == 'step2'">

          <base-button @click="goBack('step1')" type="uBind" class="mt-2 mt-sm-0 mb-4" style="width:150px"><i
              class="fas fa-angle-left pr-3"></i>Back</base-button>



          <b-card no-body class="mb-4 uBind">
            <b-card-header>
              <h2 style="font-size: 17pt" class="secondary-card-header">
                Driving and Claims History
              </h2>

              <!-- <h3 class="mb-0">Premium</h3> -->
            </b-card-header>
            <b-card-body>

              <b-row>
                <b-col md="12" class="infoText">
                  Has the client or any drivers that will or intend to drive for the client:
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Had their driving licence suspended or cancelled (for reasons other than unpaid parking fines) within
                  the last five (5) years?


                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice3">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.licenceSuspension">
                    </base-switch>
                  </base-input>
                </b-col>



              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Been convicted for driving under the influence of alcohol and/or drugs within the last five (5) years?

                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice2">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.convictedAlcoholDrug">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Had more than one (1) at-fault accident or claim lodged in connection with a motor vehicle in the last
                  three (3) years?


                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice3">
                    <base-switch id="claimsAtFault" @change="updateForm($event)" on-text="Yes"
                      off-text="No" v-model="model.atFault">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Had any claim lodged in connection with a motor vehicle incurring more than $30,000 in the last three
                  (3) years?


                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice4">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.claimLodged">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row v-if="model.priorClaims == true">
                <b-col>
                  <PastClaimsList ref="pastClaimsList" @saveClaim="saveClaim" @editPastClaim="editPastClaim"
                    @deletePastClaim="deletePastClaim" :model="model" />
                </b-col>
              </b-row>


              <b-row>
                <b-col>
                  <h3 style="font-size: 15pt" class="secondary-card-header">
                    Driver Details
                  </h3>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12" class="infoText">
                  During the policy period will there be any drivers driving:
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Prime Movers who are under the age of 23 or have had less than two (2) years of driving experience
                  with Prime Movers?



                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="dangerousGoods1">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.primeDriverUnderExperience">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Rigid vehicles, Buses or Coaches who are under the age of 21 or have had less than six (6) months of
                  driving experience with the relevant class of vehicle?



                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="dangerousGoods1">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.rigidDriverUnderExperience">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>


              <b-row>
                <b-col>
                  <h3 style="font-size: 15pt" class="secondary-card-header">
                    Vehicle Usage

                  </h3>
                </b-col>
              </b-row>

              <!-- <b-row>
                <b-col md="12" class="infoText">
                  During the policy period will there be any drivers driving:
                </b-col>
              </b-row> -->

              <b-row>

                <b-col md="10" class="answerText">
                  <p class="answerText" style="margin-bottom: 10px !important;">Will any of the vehicles be used:</p>

                  <ul>
                    <li>Within the vicinity of an aircraft or confines of an airport;</li>
                    <li>On rail tracks of any kind or on water;</li>
                    <li>In an aboveground mining or quarry site;</li>
                    <li>Underground;</li>
                    <li>On a beach, sand dunes, or other tidal prone locations; or</li>
                    <li>Any other off-road locations not listed above?</li>
                  </ul>



                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="vehicleUsage1">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.vehicleUsageOffRoad">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  <p class="answerText" style="margin-bottom: 10px !important;">Will any of the vehicles be used:</p>

                  <ul>
                    <li>For food preparation or sale (e.g. mobile food vans or trucks);</li>
                    <li>For promotional purposes (e.g. broadcast van, advertising);</li>
                    <li>For courier purposes (not including Bulk parcel delivery);</li>
                    <li>As mobile accommodation or office/work space;</li>
                    <li>In the filming industry (e.g. wardrobe &amp; make-up van, stunt vehicles); or</li>
                    <li>For any other purpose which requires a specialised fit-out?</li>
                  </ul>
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="vehicleUsage2">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.vehicleUsageSpecialFitOut">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  <p class="answerText" style="margin-bottom: 10px !important;">Will any of the vehicles be used as a:
                  </p>

                  <ul>
                    <li>Hire car/hire van;</li>
                    <li>Limousine; or</li>
                    <li>Rental vehicle e.g. Avis, Hertz, including dry hire and courtesy vehicle.</li>
                  </ul>



                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="vehicleUsage3">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.vehicleUsagePassengerHired">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  <p class="answerText" style="margin-bottom: 10px !important;">Will any of the vehicles be used as a:
                  </p>

                  <ul>
                    <li>Taxi;</li>
                    <li>Rideshare vehicle;</li>

                  </ul>


                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="vehicleUsage4">
                    <base-switch @change="onRideShareChange" on-text="Yes" off-text="No"
                      v-model="model.vehicleRideShare">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>


            </b-card-body>
          </b-card>

          <b-card no-body class="mb-4 uBind">
            <b-card-body>
              <b-row>
                <b-col md="12" style="text-align: center;">
                  <base-button v-bind:disabled="!isPage2Valid" @click="confirm('step3')" type="danger"
                    class="mb-4 bg-danger">Proceed to Disclosure Section</base-button>

                  <!-- <div v-if="isDeclined == true" class="invalid-feedback" style="display: block;">
                    Sorry, your quote cannot proceed any further. </div> -->
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </div>

        <RideshareModal ref="rideshareModal" />

        <div class="container-fluid mt--6" style="margin-top: -7.5rem !important"
          v-if="model != null && step == 'step3'">

          <base-button @click="goBack('step2')" type="uBind" class="mt-2 mt-sm-0 mb-4" style="width:150px"><i
              class="fas fa-angle-left pr-3"></i>Back</base-button>

          <!-- <b-card no-body class="mb-4 uBind">

            <b-card-header>
              <h2 style="font-size: 17pt" class="secondary-card-header">
                In Order to Finalise The Quotation Please Complete the Following Declaration
              </h2>

            </b-card-header>
            
            <b-card-body>

              <b-row>
                <b-col md="12">



                  <div class="infoText">This insurance quotation is provided to you by Insurance Advisernet Australia
                    AFSL
                    NO:
                    240549.</div>

                  <div class="infoText">Insurance Advisernet Australia is an insurance brokerage that has partnered with
                    your
                    finance broker to help you with an insurance quotation for your unregistered plant and equipment.
                  </div>

                  <div class="infoText">For full details of the Insurance Advisernet office providing this quotation
                    click
                    here: (<a target="_blank" style="color: #cc1a1a;text-decoration: underline;"
                      href="https://insuranceadviser.net/risk-advisory-australia-pty-ltd">https://insuranceadviser.net/risk-advisory-australia-pty-ltd</a>)
                  </div>


                </b-col>
              </b-row>

            </b-card-body>
          </b-card> -->


          <b-card no-body class="mb-4 uBind">
            <b-card-header>
              <h2 style="font-size: 17pt" class="secondary-card-header">
                Your Duty of Disclosure
              </h2>

              <!-- <h3 class="mb-0">Premium</h3> -->
            </b-card-header>
            <b-card-body>

              <b-row>

                <!-- <div class="infoText">According to the Insurance Contracts Act 1984 (ICA), you and everyone who is
                  insured
                  under your policy must comply with a relevant duty.</div>

                <div class="infoText">Your duty to us means no misrepresentation. It's important that you read and
                  understand
                  your duty and answer all our questions truthfully and accurately.</div> -->

                <div class="infoText">

                  <div>
                    <div>
                      <div>Before You enter into
                        a contract of insurance with Us, You have a duty under the Insurance Contracts Act 1984 to
                        disclose to Us every matter that You know, or could reasonably be expected to know, is
                        relevant to Our decision whether to accept the risk of the insurance and, if so, on what
                        terms.<br><br>You have the same duty to disclose those matters to Us before You renew, extend,
                        vary or reinstate the contract. This Duty of Disclosure applies until the contract is entered
                        into (or renewed, extended, varied or reinstated as applicable).<br><br><strong>Your duty
                          however does not require disclosure of any matter:</strong><br>
                        <ul style="margin-top: 5px; margin-bottom: 5px;">
                          <li>that diminishes the risk to be undertaken by Us; or</li>
                        </ul>

                        <ul style="margin-top: 5px; margin-bottom: 5px;">
                          <li>that is of common knowledge; or that We know or, in the ordinary course of Our business
                            as an insurer, ought to know; or</li>
                        </ul>

                        <ul style="margin-top: 5px; margin-bottom: 5px;">
                          <li>as to which compliance with Your duty is waived by Us.</li>
                        </ul>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="infoText">
                  <div>


                    <h5>Non-disclosure</h5>


                  </div>
                  <div>

                    <div>If You fail to comply
                      with Your duty of disclosure, We may be entitled to reduce Our liability under the contract in
                      respect of a claim, cancel the contract or both. If Your non-disclosure is fraudulent, We may
                      also have the option of avoiding the contract from its beginning.</div>

                  </div>
                </div>


              </b-row>




              <b-row style="margin-top: 25px">


                <!-- <div class="infoText">The insurance is provided by Chubb Insurance Australia Limited, please download
                  Target
                  Market Determination, at <a style="color: #cc1a1a;text-decoration: underline;" target="_blank"
                    href="https://www.protecsure.com.au/tmd/">this
                    link</a>. </div> -->

                <!-- <div class="infoText">Target Market Determination (TMD) is designed to assist customers, distributors
                  and
                  Chubb Insurance Australia Limited (Chubb) staff to understand who this product has been designed for
                  and
                  who
                  it is not suitable for. </div> -->

                <!-- <div class="infoText">By getting a quote with us you agree that the right <a target="_blank"
                    style="color: #cc1a1a;text-decoration: underline;" href="/downloads/protecsure-pds.pdf">PDS</a> is
                  made
                  available to you on this site. </div> -->



              </b-row>
              <b-row>
                <div class="infoText">Please see <a target="_blank" style="color: #cc1a1a;text-decoration: underline;"
                    href="https://www.gtins.com.au/wp-content/uploads/2025/06/POL554GT-Global-Transport-Driveline-Transport-Package-Policy-04.25.pdf">Product
                    Disclosure Statement and Policy Document.</a> </div>
              </b-row>
            </b-card-body>
          </b-card>

          <b-card no-body class="mb-4 uBind">
            <b-card-header>
              <h2 style="font-size: 17pt" class="secondary-card-header">
                Disclosure Details
              </h2>

              <!-- <h3 class="mb-0">Premium</h3> -->
            </b-card-header>
            <b-card-body>

              <b-row>
                <b-col md="12" class="infoText">
                  In the last five (5) years has the client or, if they are a business entity, any of its directors or
                  partners themselves:
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Been placed into receivership, liquidation or declared bankrupt?


                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice1">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.privacyNotice1">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Had an insurer decline any claim or application for insurance, cancel or refuse to renew a policy, or
                  impose special terms, conditions or restrictions on a policy?


                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice2">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.privacyNotice2">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Been convicted or had a fine or penalty imposed for any crime involving drugs, dishonesty, arson,
                  theft, fraud, or violence against any person or property?

                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice3">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.privacyNotice3">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Do you derive more than 25% of your turnover from the provision of services or supplies to (thermal)
                  Coal Mines or Coal Fired Power Plants?




                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice4">
                    <base-switch @change="updateForm($event)" on-text="Yes" off-text="No"
                      v-model="model.privacyNotice4">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <h3 style="font-size: 13pt" class="secondary-card-header">
                    Dangerous Goods Disclosure
                  </h3>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Do you transport bulk quantities of Dangerous/Hazardous Goods as specified by the Australian Dangerous
                  Goods Code?


                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="dangerousGoods1">
                    <base-switch on-text="Yes" off-text="No" v-model="model.dangerousGoods1">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>




              <b-row v-if="model.dangerousGoods1 == true">
                <b-col>
                  <DangerousGoodsList @saveDangerousGoodsItem="saveDangerousGoodsItem"
                    @editPastClaim="editDangerousGoodsItem" @deleteDangerousGoodsItem="deleteDangerousGoodsItem"
                    :model="model" />
                </b-col>
              </b-row>




            </b-card-body>
          </b-card>








          <b-card class="uBind">
            <b-card-body>
              <b-row>
                <b-col md="12" style="margin-bottom: 20px;margin-top:0px; text-align: left;">
                  <div style="margin: auto; margin-bottom: 20px" class="infoText">The information
                    provided
                    is
                    to be regarded as general advice. Whilst we may have collected risk information, your personal
                    objectives,
                    needs or financial situations were not taken into account when preparing this information.</div>

                  <div style="margin: auto;" class="infoText">We recommend that you consider the
                    suitability
                    of this general advice, in respect of your objectives, financial situation and needs before acting
                    on
                    it.
                    You should obtain and consider the relevant product disclosure statement before making any decision
                    to
                    purchase this financial product. </div>
                </b-col>
              </b-row>

              <b-row v-if="model.acceptDOD != true">
                <b-col md="12" style="text-align: center;">
                  <div class="invalid-feedback" style="display: block; font-size: 10pt; font-weight: bold;">
                    Please confirm the 3 statements below. </div>
                </b-col>
              </b-row>

              <b-row class=" my-4">
                <b-col cols="12" style="margin-bottom: 0px;margin-top:0px; text-align: center;">
                  <base-input :rules="{ required: { allowFalse: false } }" name="above">
                    <b-form-checkbox v-model="model.agreeAdviceDisclosure" class="consent-checkbox">
                      <span>I have read the general advice disclosure and accept the conditions.</span>
                    </b-form-checkbox>
                  </base-input>
                </b-col>
              </b-row>
              <b-row class=" my-4">
                <b-col cols="12" style="margin-bottom: 00px;margin-top:0px; text-align: center;">
                  <base-input :rules="{ required: { allowFalse: false } }" name="above">
                    <b-form-checkbox v-model="model.agree" class="consent-checkbox">
                      <span>I confirm that the above information I have provided is true and correct.</span>
                    </b-form-checkbox>
                  </base-input>
                </b-col>
              </b-row>

              <b-row class="" style="margin-top: 25px;">
                <b-col md="12" class="answerText" style="margin-bottom:0px;  text-align: center;">

                  <div style="margin-bottom: 20px;">I confirm I have read the duty of disclosure and accept the conditions.</div>

                  <!-- <base-input name="acceptDOD">
                <base-switch on-text="Yes" off-text="No" v-model="model.acceptDOD">
                </base-switch>
              </base-input> -->

                  <div>
                    <base-input :rules="{ required: { allowFalse: true } }" name="Acceptance of Duty of Disclosure">
                      <el-select id="acceptDOD" v-model="model.acceptDOD" style="width:200px"
                        class="duty-disclosure-select">
                        <el-option label="-- Please select --" :value="null"></el-option>
                        <el-option label="No" :value="false"></el-option>
                        <el-option label="Yes" :value="true"></el-option>
                      </el-select>
                    </base-input>
                  </div>
                </b-col>
              </b-row>


            </b-card-body>
          </b-card>








          <b-card class="uBind">
            <b-card-body>



              <b-row>
                <b-col md="12" style="text-align: center;">

                  <div v-if="informationSubmitted == false && shouldShowReferralSubmitOnly"
                    class="payment-terms-referral-submit">
                    <div class="infoText payment-terms-placeholder">
                      Please submit your information below and a member of our team will be in touch with you
                      shortly
                    </div>

                    <base-button type="danger" class="mb-4 bg-danger"
                      :disabled="!(model.agree && model.agreeAdviceDisclosure && model.acceptDOD == true) || isSubmittingInformation"
                      @click="submitInformation()">
                      <span v-if="isSubmittingInformation">
                        <b-spinner small class="mr-2"></b-spinner>
                        Processing...
                      </span>
                      <span v-else>Submit Information</span>
                    </base-button>
                  </div>

                  <div v-else-if="informationSubmitted == false" ref="paymentTermsSection" id="paymentTermsSection">
                    <div v-if="isCloudfloatRetryFlow" class="infoText payment-terms-retry-notice">
                      There was a problem completing your Cloudfloat monthly payment setup.
                      You can still proceed by paying annually using the option below.
                      Once you accept the quote, you will be sent an invoice for the full premium amount.
                    </div>

                    <h2 style="font-size: 17pt" class="secondary-card-header payment-terms-heading">
                      Payment Terms
                    </h2>
                    <div v-if="!isCloudfloatRetryFlow" class="infoText payment-terms-helper">
                      Please Select your Payment Terms
                    </div>

                    <div class="payment-terms-panel">
                      <ButtonRadioGroup v-if="!isCloudfloatRetryFlow" v-model="paymentTerm"
                        :options="paymentTermOptions" class="payment-terms-toggle" buttonClasses="payment-term-button"
                        @change="paymentTermChanged" />

                      <div v-if="paymentTerm == 'monthly'"
                        class="infoText payment-terms-placeholder payment-terms-monthly-panel">
                        <div v-if="isLoadingCloudfloatQuote" class="cloudfloat-loading-inline">
                          <div class="cloudfloat-orbit-spinner">
                            <div class="orbit"></div>
                            <div class="orbit"></div>
                            <div class="orbit"></div>
                          </div>
                          <p class="payment-terms-loading-text">Loading monthly installment options...</p>
                        </div>

                        <div v-else-if="hasCloudfloatQuoteData" class="cloudfloat-quote">
                          <div class="cloudfloat-brand">
                            <div style="margin-bottom: 0px;" class="cloudfloat-powered-by">Powered by</div>
                            <img src="/img/brand/cloudfloat-logo.png" alt="Cloudfloat" class="cloudfloat-logo" />
                          </div>

                          <div class="cloudfloat-card">
                            <div class="cloudfloat-summary-row">
                              <span>Annual Premium</span>
                              <strong>{{ formatCentsAsCurrency(cloudfloatQuoteData.annual_premium_in_cents) }}</strong>
                            </div>

                            <div class="cloudfloat-divider"></div>

                            <div class="cloudfloat-schedule">
                              <div class="cloudfloat-schedule-item">
                                <div class="cloudfloat-schedule-track">
                                  <span style="width:24px; height:24px;"
                                    class="cloudfloat-step cloudfloat-step--active">1</span>
                                  <span class="cloudfloat-step-line"></span>
                                </div>
                                <div class="cloudfloat-schedule-content">
                                  <span class="cloudfloat-schedule-label">Due today</span>
                                  <strong class="cloudfloat-schedule-amount">{{
                                    formatCentsAsCurrency(cloudfloatQuoteData.upfront_amount_in_cents)
                                    }}</strong>
                                </div>
                              </div>

                              <div class="cloudfloat-schedule-item">
                                <div class="cloudfloat-schedule-track">
                                  <span class="cloudfloat-step-dots" aria-hidden="true">
                                    <span></span><span></span><span></span>
                                  </span>
                                  <span class="cloudfloat-step-line"></span>
                                </div>
                                <div class="cloudfloat-schedule-content">
                                  <span style="margin-top: 6px;" class="cloudfloat-schedule-label">Monthly</span>
                                  <strong class="cloudfloat-schedule-amount">{{
                                    formatCentsAsCurrency(cloudfloatQuoteData.recurring_instalment_amount_in_cents)
                                    }}</strong>
                                </div>
                              </div>

                              <div class="cloudfloat-schedule-item cloudfloat-schedule-item--last">
                                <div class="cloudfloat-schedule-track">
                                  <span style="width:25px; height:25px; background: #dbdcdd; margin-top: 3px;"
                                    class="cloudfloat-step cloudfloat-step--final">{{
                                      cloudfloatQuoteData.total_number_instalments
                                    }}</span>
                                </div>
                                <div class="cloudfloat-schedule-content">
                                  <span class="cloudfloat-schedule-label">{{ cloudfloatFinalInstalmentDateFormatted
                                    }}</span>
                                  <strong class="cloudfloat-schedule-amount">{{
                                    formatCentsAsCurrency(cloudfloatQuoteData.recurring_instalment_amount_in_cents)
                                    }}</strong>
                                </div>
                              </div>
                            </div>

                            <div class="cloudfloat-divider"></div>

                            <div class="cloudfloat-summary-row">
                              <span>Fee per instalment (incl GST)</span>
                              <strong>{{ formatCentsAsCurrency(cloudfloatQuoteData.fee_per_instalment_in_cents)
                                }}</strong>
                            </div>
                            <div class="cloudfloat-summary-row cloudfloat-summary-row--total">
                              <span>Total to repay</span>
                              <strong>{{ formatCentsAsCurrency(cloudfloatQuoteData.final_agreed_amount_in_cents)
                                }}</strong>
                            </div>
                          </div>

                          <base-button type="danger" class="cloudfloat-cta-button" :disabled="isSavingCloudfloatQuote"
                            @click="continueToCloudfloat()">
                            <span v-if="isSavingCloudfloatQuote">
                              <b-spinner small class="mr-2"></b-spinner>
                              Saving...
                            </span>
                            <span v-else>Continue to Cloudfloat to setup payment plan</span>
                          </base-button>
                        </div>

                        <div v-else-if="cloudfloatQuoteLoadError" class="payment-terms-load-error">
                          {{ cloudfloatQuoteLoadError }}
                        </div>
                      </div>

                      <div v-if="paymentTerm == 'annual'" class="payment-terms-actions">

                        <div class="infoText payment-terms-placeholder">
                          You will be sent an invoice for the premium amount of <b>{{ estimatedPremiumFormatted }}</b>,
                          which will require payment within 14 days. You will also be sent your Documentation,
                          including Certificate of Currency.
                        </div>

                        <base-button
                          :disabled="!(model.agree && model.agreeAdviceDisclosure && model.acceptDOD == true) || isAcceptingQuote || filesUploading"
                          @click="acceptQuote()" type="danger" class="mb-4 bg-danger">
                          <span v-if="isAcceptingQuote">
                            <b-spinner small class="mr-2"></b-spinner>
                            Processing...
                          </span>
                          <span v-else>Accept Quote and Bind Cover</span>
                        </base-button>
                      </div>
                    </div>
                  </div>

                </b-col>
              </b-row>

            </b-card-body>

          </b-card>
        </div>
        <div class="container-fluid mt--6" style="margin-top: -7.5rem !important"
          v-if="model != null && step == 'outcome'">

          <b-card no-body class="mb-4 uBind">
            <b-card-header>
              <h2 style="font-size: 17pt" class="secondary-card-header">
                Thank you
              </h2>
            </b-card-header>
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <div class="infoText">
                    We need a little more information from you before we can proceed. Kym from the Transport Protect
                    team will contact you shortly to assist and finalise the terms with the insurer. Thank you for your
                    patience and understanding.
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>

        </div>
        <div class="container-fluid mt--6" style="margin-top: -7.5rem !important"
          v-if="model != null && step == 'accepted'">

          <!-- <base-button @click="goBack()" type="uBind" class="mt-2 mt-sm-0 mb-4" style="width:150px"><i
          class="fas fa-angle-left pr-3"></i>Back</base-button> -->

          <b-card no-body class="mb-4 uBind">



            <b-card-header>
              <h2 style="font-size: 17pt" class="secondary-card-header">
                Thank you
              </h2>

              <!-- <h3 class="mb-0">Premium</h3> -->
            </b-card-header>
            <b-card-body>

              <b-row>
                <b-col md="12">
                  <div class="infoText">Thank you for completing the disclosure questions. A member of the Transport
                    Protect team is preparing your documents and they will be emailed to you shortly.</div>

                </b-col>
              </b-row>

            </b-card-body>
          </b-card>

        </div>



        <b-card v-if="apiErrors.length > 0" class="uBind apiError2">
          <h3>Error</h3>
          <h4>Please review the following errors.</h4>

          <div v-for="(item, index) in apiErrors" :key="index" style="display: inline-flex; color: white; width: 100%;">
            <div style="flex-basis: 200px;">Error Code: {{ item.errorCode }}</div>
            <div style="flex-basis: 100%;">Error Description: {{ item.errorMessage }}</div>
          </div>

        </b-card>








      </form>
    </validation-observer>

    <VehicleModal :showFreightTask="true" ref="vehicleModal" :hasTrailerLiability="hasTrailerLiability"
      @saveVehicle="saveVehicle($event)" />

  </div>

</template>

<script>
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonRadioGroup from "../../components/ButtonRadioGroup.vue";
import { Select, Option } from "element-ui";
import { dropDowns } from "../../assets/data/dropdown_values";
import { quoteFormMethods } from "../../helpers/quoteForm";
import { GlobalStore } from "../../globalStore";
import { emailMethods } from "../../helpers/email";
import { appFunctions } from "../../helpers/appFunctions";
import { motorQuoteStatus } from "../../constants/motorQuoteStatus";
import { protecsureFunctions } from "../../helpers/protecsure";
import Spinner from "../../views/dashboard/Spinner.vue";
import FileUpload from 'vue-upload-component'
import { GlobalMethods } from "../../globalMethods";
import VueMultiselectComponent from 'vue-multiselect-component'
import { entsiaDropDowns } from "../../assets/data/entsiaLOVs";
import VehicleModal from "./modals/vehicleModal.vue"
import PastClaimsList from "./components/pastClaimsList.vue";
import RideshareModal from "./modals/rideshareModal.vue";
import { formattingMethods } from "../../helpers/formatting";
import { entsiaFunctions } from "../../helpers/entsia";
import DangerousGoodsList from "./components/dangerousGoodsList.vue";

// import QuotesAndPoliciesVue from "../views/QuotesAndPolicies.vue";

export default {
  name: "QuoteForm",
  policy_id: "",
  selectedCustomerId: 0,
  props: {
    rawModel: null,
    editModel: {
      type: Object
    },
    formMode: {
      type: String,
      default: "create"
    }
  },



  //                   <el-option label="Locked Shed" value="Locked Shed" />
  //                   <el-option label="Locked Trailer" value="Locked Trailer" />
  //                   <el-option label="Secure Compound" value="Secure Compound" />
  //                   <el-option label="Back to base alarm" value="Back to base alarm" />
  //                   <el-option label="24 hour tracking device" value="24 hour tracking device" />
  //                   <el-option label="Wheel lock nuts" value="Wheel lock nuts" />
  //                   <el-option label="Immoboliser" value="Immoboliser" />
  //                   <el-option label="Microdotting" value="Microdotting" />
  //                   <el-option label="Other" value="other" />




  data() {
    return {
      //value: [],
      nswSdExemptionDeclaration: false,
      paymentTerm: "annual",
      isLoadingCloudfloatQuote: false,
      cloudfloatQuoteRequested: false,
      cloudfloatQuoteResponse: null,
      cloudfloatQuoteLoadError: null,
      isSavingCloudfloatQuote: false,
      isAcceptingQuote: false,
      isSubmittingInformation: false,
      informationSubmitted: false,
      checkedVehicleDetails: false,
      hasbeenReferred: false,
      vehicleEditMode: 'add',
      selectedItem: null,
      selectedItemIndex: null,
      businessDescriptionsOptions: entsiaDropDowns.businessDescriptionsOptions,
      quoteModified: false,
      selectedSecurity1: [],
      excessOptions: [],
      formInitData: null,
      security1_other: "",


      carModels: entsiaDropDowns.carModels,

      security1options: [
        { id: 'Not Sure', label: 'Not Sure' },
        { id: 'On the street', label: 'On the street' },
        { id: 'Garage', label: 'Garage' },
        { id: 'Driveway of property', label: 'Driveway of property' },
        { id: 'Other', label: 'Other' },
      ],
      selectedSecurity2: [],
      security2_other: "",
      security3: "",
      security2options: [
        { id: 'Not Sure', label: 'Not Sure' },
        { id: 'Locked Shed', label: 'Locked Shed' },
        { id: 'Locked Trailer', label: 'Locked Trailer' },
        { id: 'Back to Base Alarm', label: 'Back to Base Alarm' },
        { id: '24 hour tracking device', label: '24 hour tracking device' },
        { id: 'Wheel lock nuts', label: 'Wheel lock nuts' },
        { id: 'Immoboliser', label: 'Immoboliser' },
        { id: 'Microdotting', label: 'Microdotting' },
        { id: 'Other', label: 'Other' },
      ],
      selectedSecurity4: [],
      security4_other: "",
      security4options: [
        { id: 'Not Sure', label: 'Not Sure' },
        { id: 'Locked Shed', label: 'Locked Shed' },
        { id: 'Locked Trailer', label: 'Locked Trailer' },
        { id: 'Secure Compound', label: 'Secure Compound' },
        { id: 'Back to Base Alarm', label: 'Back to Base Alarm' },

        { id: '24 hour tracking device', label: '24 hour tracking device' },
        { id: 'Wheel lock nuts', label: 'Wheel lock nuts' },
        { id: 'Immoboliser', label: 'Immoboliser' },
        { id: 'Microdotting', label: 'Microdotting' },
        { id: 'Other', label: 'Other' },
      ],
      isLoading: false,
      formInitData: { equipmentCategories: [] },
      selectEquipmentItems: [],
      quoteNotes: [],
      certContents: "",
      realmApp: null,
      //formMode: "create",
      financiers: [
        { label: "Don't know", value: "Don't know" },
        ...dropDowns.financiers,
      ],
      equipmentTypes: dropDowns.protecSureEquipmentTypes,
      states: dropDowns.states,
      operatingAreas: dropDowns.operatingAreas,
      usedOnPublicRoadOptions: dropDowns.usedOnPublicRoadOptions,
      validated: false,
      financierOtherDisabled: true,
      enteredInsuredName: "",
      customerList: [],
      fileList: [],
      uploaderKey: 'customerQuoteFileUploader',
      step: "step1",
      model: null,
      mode: "view",
      equipmentTypes: dropDowns.protecSureEquipmentTypes,
      states: dropDowns.states,
      operatingAreas: dropDowns.operatingAreas,
      primaryGoodsOptions: entsiaDropDowns.primaryGoodsOptions,
      primaryGoodsOtherOptions: entsiaDropDowns.primaryGoodsOtherOptions,
      usedOnPublicRoadOptions: dropDowns.usedOnPublicRoadOptions,
      numberOfVehiclesOptions: dropDowns.numberOfVehiclesOptions,
      vehicleBrandOptions: dropDowns.vehicleBrandOptions,
      vehicleModelOptions: dropDowns.vehicleModelOptions,
      freightTaskOptions: entsiaDropDowns.freightTaskOptions,
      vehicleTypeOptions: entsiaDropDowns.vehicleTypeOptions,
      currentInsurerOptions: dropDowns.currentInsurerOptions,
      timeInBusinessOptions: entsiaDropDowns.timeInBusinessOptions,
      radiusOfOperation: entsiaDropDowns.radiusOfOperation,
      currentInsurers: entsiaDropDowns.currentInsurers,
      reasonsNotInsured: entsiaDropDowns.reasonsNotInsured,
      apiErrors: [],
      underwritingMessages: [],
      validationMessages: []
    };
  },
  computed: {

    filesUploading() {
      return (this.fileList || []).some((f) => !f.success);
    },
    hasTrailerLiability() {
      return ((this.model && this.model.vehicles) || []).some(
        (v) => v.vehicle && v.vehicle.coverType === "NOTLIA"
      );
    },
    isPage2Valid() {

      if (this.model.priorClaims == true && this.model.listOfClaims.length == 0) {
        return false;
      }
      return true;
    },
    isDeclined() {
      if (this.model.licenceSuspension == true
        || this.model.convictedAlcoholDrug == true
        || this.model.primeDriverUnderExperience == true
        || this.model.rigidDriverUnderExperience == true
        || this.model.vehicleUsageOffRoad == true
        //|| this.model.vehicleRideShare == true
        || this.model.vehicleUsagePassengerHired == true

        || this.model.privacyNotice1 == true
        || this.model.privacyNotice2 == true
        || this.model.privacyNotice3 == true
        || this.model.privacyNotice4 == true
        || this.model.privacyNotice5 == true
        //|| this.hasbeenReferred == true
      ) {
        return true;
      }
      return false;
    },
    localDeclinedReasons() {
      if (!this.model) {
        return [];
      }

      const reasonRules = [
        {
          field: "privacyNotice2",
          reason: "We're unable to provide cover due to previous insurance declined, cancelled, not renewed, or had special conditions imposed."
        },
        {
          field: "privacyNotice1",
          reason: "We're unable to provide cover due to receivership, liquidation or bankruptcy within the last 5 years."
        },
        {
          field: "privacyNotice3",
          reason: "We're unable to provide cover due to convictions or penalties for drugs, dishonesty, arson, theft, fraud, or violence."
        },
        {
          field: "privacyNotice4",
          reason: "We're unable to provide cover due to coal-related turnover."
        },
        {
          field: "privacyNotice5",
          reason: "We're unable to provide cover due to an undisclosed matter or exceptional circumstance that may affect the insurer's decision."
        },
        {
          field: "licenceSuspension",
          reason: "We're unable to provide cover due to licence suspension or cancellation within the last 5 years (excluding unpaid parking fines)."
        },
        {
          field: "convictedAlcoholDrug",
          reason: "We're unable to provide cover due to drink or drug driving convictions within the last 5 years."
        },
        {
          field: "primeDriverUnderExperience",
          reason: "We're unable to provide cover for prime mover drivers under 23 or with less than 2 years' experience on this vehicle class."
        },
        {
          field: "rigidDriverUnderExperience",
          reason: "This quote has been declined due to driver age and/or inexperience with vehicles of the proposed class."
        },
        {
          field: "vehicleUsageOffRoad",
          reason: "We're unable to provide cover for off-road vehicle usage."
        },
        {
          field: "vehicleUsagePassengerHired",
          reason: "As this vehicle is being used for Hire, Fare or Reward it cannot be quoted online."
        }
      ];

      return reasonRules
        .filter((rule) => this.model[rule.field] === true)
        .map((rule) => rule.reason);
    },
    localReferredReasons() {
      if (!this.model) {
        return [];
      }

      const reasons = [];

      if (this.model.vehicleRideShare == true) {
        reasons.push(
          "We're unable to quote online for rideshare or hire vehicles. We will pass this onto Transport Protect who specialise in Rideshare insurance experts & they will contact you shortly."
        );
      }

      if (this.model.vehicleUsageSpecialFitOut == true) {
        reasons.push(
          "Quote referred due to specialised vehicle usage or fit-out (e.g. food preparation or sale, promotional, courier, mobile accommodation/office, filming industry, or other specialised fit-out)."
        );
      }

      if (this.model.atFault == true) {
        reasons.push(
          "Had more than one (1) at-fault accident or claim lodged in connection with a motor vehicle in the last three (3) years."
        );
      }

      if (this.model.claimLodged == true) {
        reasons.push(
          "Had any claim lodged in connection with a motor vehicle incurring more than $30,000 in the last three (3) years."
        );
      }

      return reasons;
    },
    declinedUnderwritingMessages() {
      if (!this.underwritingMessages || !this.underwritingMessages.length) {
        return [];
      }

      return this.underwritingMessages.filter((message) => {
        return String(message && message.underwritingDecision || "").toUpperCase() === "DECLINED";
      });
    },
    hasDeclinedUnderwritingMessages() {
      return this.declinedUnderwritingMessages.length > 0;
    },
    shouldShowReferralSubmitOnly() {
      return (
        this.informationSubmitted == false &&
        (this.hasbeenReferred == true || this.isDeclined == true)
      );
    },
    cloudfloatQuoteData() {
      return this.cloudfloatQuoteResponse && this.cloudfloatQuoteResponse.data
        ? this.cloudfloatQuoteResponse.data
        : this.cloudfloatQuoteResponse;
    },
    hasCloudfloatQuoteData() {
      const data = this.cloudfloatQuoteData;
      return !!(data && data.annual_premium_in_cents != null);
    },
    cloudfloatFinalInstalmentDateFormatted() {
      const data = this.cloudfloatQuoteData;
      if (!data) {
        return "";
      }

      const totalInstalments = Number(data.total_number_instalments);
      const remainingInstalments = Number(data.number_remaining_instalments);
      const recurringCount =
        Number.isFinite(remainingInstalments) && remainingInstalments > 0
          ? remainingInstalments
          : Number.isFinite(totalInstalments)
            ? Math.max(totalInstalments - 1, 0)
            : 0;

      if (recurringCount <= 0) {
        return this.$moment().format("D MMMM YYYY");
      }

      let firstRecurringDate;
      if (data.payout_date) {
        firstRecurringDate = this.$moment(data.payout_date);
      } else if (data.issued_at) {
        firstRecurringDate = this.$moment(data.issued_at).add(1, "month");
      } else {
        firstRecurringDate = this.$moment().add(1, "month");
      }

      return firstRecurringDate
        .clone()
        .add(recurringCount - 1, "months")
        .format("D MMMM YYYY");
    },
    isFormValid() {
      var isValid = true;

      isValid = this.selectEquipmentItems.length > 0;

      return isValid;
    },
    fieldsDisabled() {
      return this.getDisabledFields(
        this.formMode,
        this.model.Customer_policy_status
      );
    },
    formRules() {
      return quoteFormMethods.getFormRules("in_progress");
    },
    brokerObj() {
      return GlobalStore.brokerObj;
    },
    validationMessagesForCard() {
      if (!this.validationMessages || !this.validationMessages.length) {
        return [];
      }
      return this.validationMessages.filter(
        (m) => m && m.messageType !== "INFORMATION"
      );
    },
    estimatedPremiumFormatted() {
      if (!this.model || !this.model.Data_obj || this.model.Data_obj.totalPremiumIncFees == null) {
        return this.formatCurrencyString(0);
      }
      return this.formatCurrencyString(parseFloat(this.model.Data_obj.totalPremiumIncFees));
    },
    isCloudfloatRetryFlow() {
      return String(this.$route?.query?.flow || "").toLowerCase() === "retry";
    },
    paymentTermOptions() {
      const options = [
        { value: "annual", label: "Annual Payment" },
        { value: "monthly", label: "Monthly installments" },
      ];
      if (this.isCloudfloatRetryFlow) {
        return options.filter((option) => option.value === "annual");
      }
      return options;
    },
  },
  watch: {
    paymentTerm(value) {
      if (value === "monthly") {
        this.requestMonthlyInstallmentQuote(true);
      }
    },
  },
  methods: {
    getAustralianStateFromPostcode(postcode) {
      const parsedPostcode = parseInt(postcode, 10);

      if (isNaN(parsedPostcode)) {
        return "Invalid Postcode";
      }

      // New South Wales (NSW)
      if ((parsedPostcode >= 1000 && parsedPostcode <= 1999) ||
        (parsedPostcode >= 2000 && parsedPostcode <= 2599) ||
        (parsedPostcode >= 2640 && parsedPostcode <= 2899) ||
        (parsedPostcode >= 2921 && parsedPostcode <= 2999)) {
        return 'NSW';
      }
      // Australian Capital Territory (ACT)
      else if ((parsedPostcode >= 200 && parsedPostcode <= 299) ||
        (parsedPostcode >= 2600 && parsedPostcode <= 2639) ||
        (parsedPostcode >= 2900 && parsedPostcode <= 2920)) {
        return 'ACT';
      }
      // Victoria (VIC)
      else if ((parsedPostcode >= 3000 && parsedPostcode <= 3999) ||
        (parsedPostcode >= 8000 && parsedPostcode <= 8999)) {
        return 'VIC';
      }
      // Queensland (QLD)
      else if ((parsedPostcode >= 4000 && parsedPostcode <= 4999) ||
        (parsedPostcode >= 9000 && parsedPostcode <= 9999)) {
        return 'QLD';
      }
      // South Australia (SA)
      else if ((parsedPostcode >= 5000 && parsedPostcode <= 5799) ||
        (parsedPostcode >= 5800 && parsedPostcode <= 5999)) {
        return 'SA';
      }
      // Western Australia (WA)
      else if ((parsedPostcode >= 6000 && parsedPostcode <= 6797) ||
        (parsedPostcode >= 6800 && parsedPostcode <= 6999)) {
        return 'WA';
      }
      // Tasmania (TAS)
      else if (parsedPostcode >= 7000 && parsedPostcode <= 7999) {
        return 'TAS';
      }
      // Northern Territory (NT)
      else if ((parsedPostcode >= 800 && parsedPostcode <= 999) ||
        (parsedPostcode >= 8000 && parsedPostcode <= 8999)) { // Note: NT postcodes also fall into the 8000-8999 range which is shared with VIC for LVRs/PO Boxes. This function prioritizes NT for these ranges.
        return 'NT';
      }

      return 'Unknown State';
    },
    replaceAmp(ampString) {
      var fixedString = ampString.replace("&amp;", "&");
      return fixedString;
    },
    paymentTermChanged(value) {
      if (value == "monthly") {
        this.requestMonthlyInstallmentQuote(true);
      }
    },
    async requestMonthlyInstallmentQuote(force = false) {
      if (this.isLoadingCloudfloatQuote) {
        return;
      }
      if (!force && this.cloudfloatQuoteRequested) {
        return;
      }

      this.isLoadingCloudfloatQuote = true;
      this.cloudfloatQuoteLoadError = null;
      if (force) {
        this.cloudfloatQuoteResponse = null;
        this.cloudfloatQuoteRequested = false;
      }

      const annualPremiumInCents = Math.round(parseFloat(this.model.Data_obj.totalPremiumIncFees) * 100);

      try {
        const response = await entsiaFunctions.requestCloudfloatQuote(
          annualPremiumInCents,
          {
            abn:
              this.model.Customer_abn ||
              this.model.insuredABN ||
              this.model.Data_obj?.messageData?.policy?.insured?.insuredRoot?.abn ||
              this.model.Data_obj?.messageData?.policy?.insured?.abn ||
              "",
            first_name: this.model.Customer_contact_first_name || "",
            middle_name: "",
            last_name: this.model.Customer_contact_last_name || "",
            email: this.model.Customer_contact_email || "",
            phone: this.model.Customer_contact_number || ""
          },
          this.model.Customer_policy_guid || ""
        );
        this.cloudfloatQuoteResponse = response;
        this.cloudfloatQuoteRequested = true;
        console.log("Cloudfloat quote response", response);
      } catch (error) {
        console.error("Cloudfloat quote request failed", error);
        this.cloudfloatQuoteLoadError = "Unable to load monthly installment options. Please try again.";
        this.cloudfloatQuoteRequested = true;
      } finally {
        this.isLoadingCloudfloatQuote = false;
      }
    },
    async continueToCloudfloat() {
      const guid = this.model && this.model.Customer_policy_guid;
      if (!guid) {
        console.error("continueToCloudfloat: no Customer_policy_guid on model");
        return;
      }
      if (!this.cloudfloatQuoteData) {
        return;
      }

      this.isSavingCloudfloatQuote = true;
      try {
        const response = await entsiaFunctions.saveMotorCloudfloatQuote(
          guid,
          this.cloudfloatQuoteData
        );
        if (response && response.updatedQuote) {
          this.model.cloudfloatQuote = response.updatedQuote.cloudfloatQuote;
        } else {
          this.model.cloudfloatQuote = this.cloudfloatQuoteData;
        }

        const checkoutUrl =
          (response && response.checkoutUrl) ||
          this.buildCloudfloatCheckoutUrl(this.cloudfloatQuoteData.quote_id);

        if (checkoutUrl) {
          window.location.assign(checkoutUrl);
        } else {
          console.error("continueToCloudfloat: missing checkout URL");
        }
      } catch (error) {
        console.error("Failed to save Cloudfloat quote to customerPolicy", error);
      } finally {
        this.isSavingCloudfloatQuote = false;
      }
    },
    buildCloudfloatCheckoutUrl(quoteId) {
      if (!quoteId) {
        return "";
      }

      const apiEndpoint = String(process.env.VUE_APP_APIENDPOINT || "");
      const siteUrl = String(process.env.VUE_APP_SITEURL || "");
      const isUat = /uat/i.test(apiEndpoint) || /staging/i.test(siteUrl);

      const base = isUat
        ? "https://checkout.uat.cloudfloat.com"
        : "https://checkout.cloudfloat.com";

      return `${base}/${quoteId}`;
    },
    formatCentsAsCurrency(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      const amount = Number(value) / 100;
      if (!Number.isFinite(amount)) {
        return "";
      }

      return "$" + amount.toLocaleString("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    toEntsiaYesNo(value) {
      return value === true ? "YES" : "NO";
    },
    ensureObjectPath(target, path) {
      var current = target;

      for (var key of path) {
        if (!current[key] || typeof current[key] !== "object") {
          current[key] = {};
        }
        current = current[key];
      }

      return current;
    },
    buildMotorQuoteSnapshotForPersistence() {
      var modelToPersist = structuredClone(this.model);
      var policy = this.ensureObjectPath(modelToPersist, ["Data_obj", "messageData", "policy"]);
      var sharedPolicySubproduct = this.ensureObjectPath(policy, ["sharedPolicySubproduct"]);
      var disclosureDetails = this.ensureObjectPath(sharedPolicySubproduct, ["disclosureDetails"]);
      var sharedLiabilityGeneralBusiness = this.ensureObjectPath(policy, ["sharedLiabilitySubproduct", "generalBusinessDetails"]);
      var commercialMotorSubproduct = this.ensureObjectPath(policy, ["commercialMotorSubproduct"]);
      var generalMotorDetails = this.ensureObjectPath(commercialMotorSubproduct, ["generalMotorDetails"]);
      var motorDisclosure = this.ensureObjectPath(commercialMotorSubproduct, ["motorDisclosure"]);
      var vehiclesAndGoods = this.ensureObjectPath(commercialMotorSubproduct, ["vehiclesAndGoods"]);
      var dangerousGoodsDisclosure = this.ensureObjectPath(commercialMotorSubproduct, ["dangerousGoodsDisclosure"]);

      for (var vehicle of modelToPersist.vehicles || []) {
        if (vehicle.vehicle) {
          vehicle.vehicle.sumInsured = parseFloat(vehicle.vehicle.sumInsured);
          vehicle.vehicle.basicExcess = parseFloat(vehicle.vehicle.basicExcess);
          vehicle.vehicle.makeListNotFound = "YES";
          if (vehicle.vehicle.motorwebGlasses) {
            vehicle.vehicle.manualMake = vehicle.vehicle.motorwebGlasses.make;
          }
        }
      }

      sharedLiabilityGeneralBusiness.businessDescription = this.model.businessDesc;
      generalMotorDetails.occupationCode = this.model.businessDesc;
      generalMotorDetails.yearsOfOperation = this.model.lengthOfOperating;
      generalMotorDetails.radiusOfOperation = this.model.radiusOfOperation;
      generalMotorDetails.nswSdExemption = this.toEntsiaYesNo(this.model.nswSdExemption);
      generalMotorDetails.nswSdExemptionDeclaration = this.toEntsiaYesNo(this.model.nswSdExemption == true);

      disclosureDetails.priorClaims = this.toEntsiaYesNo(this.model.priorClaims);
      disclosureDetails.listOfClaims = this.model.listOfClaims;
      disclosureDetails.bankruptcy = this.toEntsiaYesNo(this.model.privacyNotice1);
      disclosureDetails.claimDenied = this.toEntsiaYesNo(this.model.privacyNotice2);
      disclosureDetails.criminalConviction = this.toEntsiaYesNo(this.model.privacyNotice3);
      disclosureDetails.thermalCoalMines = this.toEntsiaYesNo(this.model.privacyNotice4);

      motorDisclosure.licenceSuspension = this.toEntsiaYesNo(this.model.licenceSuspension);
      motorDisclosure.convictedAlcoholDrug = this.toEntsiaYesNo(this.model.convictedAlcoholDrug);
      motorDisclosure.atFault = this.toEntsiaYesNo(this.model.atFault);
      motorDisclosure.claimLodged = this.toEntsiaYesNo(this.model.claimLodged);
      motorDisclosure.primeDriverUnderExperience = this.toEntsiaYesNo(this.model.primeDriverUnderExperience);
      motorDisclosure.rigidDriverUnderExperience = this.toEntsiaYesNo(this.model.rigidDriverUnderExperience);

      vehiclesAndGoods.primaryGood = this.model.primaryGoods;
      vehiclesAndGoods.listOfAdditionalGoods = this.buildListOfAdditionalGoods();
      vehiclesAndGoods.currentlyInsured = this.toEntsiaYesNo(this.model.currentlyInsured);
      vehiclesAndGoods.vehicleUsageOffRoad = this.toEntsiaYesNo(this.model.vehicleUsageOffRoad);
      vehiclesAndGoods.vehicleUsageSpecialFitOut = this.toEntsiaYesNo(this.model.vehicleUsageSpecialFitOut);
      vehiclesAndGoods.vehicleUsagePassengerHired = this.toEntsiaYesNo(this.model.vehicleUsagePassengerHired);
      vehiclesAndGoods.listOfVehicles = modelToPersist.vehicles;
      if (this.model.currentlyInsured == false) {
        vehiclesAndGoods.uninsuredReason = this.model.reasonNotInsured || "1";
        delete vehiclesAndGoods.previousInsurer;
      }
      if (this.model.currentlyInsured == true) {
        delete vehiclesAndGoods.uninsuredReason;
        vehiclesAndGoods.previousInsurer = this.model.currentInsurer;
      }

      dangerousGoodsDisclosure.bulkDangerousGoodsCarried = this.toEntsiaYesNo(this.model.dangerousGoods1);
      dangerousGoodsDisclosure.listOfDangerousGoods = this.model.listOfDangerousGoods;

      return modelToPersist;
    },
    async updateTimeInBusines() {
      this.model = this.modifyNCB(this.model);
      this.refreshQuote();
    },
    async submitInformation() {
      if (this.isSubmittingInformation) {
        return;
      }
      this.isSubmittingInformation = true;
      try {
        let status = null;
        let emailTemplate = null;
        let customerEmailTemplate = null;
        let declinedReasons = [];
        let referredReasons = [];

        if (this.isDeclined == true || this.hasDeclinedUnderwritingMessages == true) {

          status = motorQuoteStatus.quoteDeclinedBasedOnUnderwritingQuestions;
          emailTemplate = "live-motor-declined-email";
          customerEmailTemplate = "live-motor-declined-email-to-customer";
          declinedReasons = [
            ...(this.isDeclined == true ? this.localDeclinedReasons : []),
            ...this.declinedUnderwritingMessages
          ];

        } else if (this.hasbeenReferred == true) {

          status = motorQuoteStatus.quoteReferredBasedOnUnderwritingQuestions;
          if (this.model.vehicleRideShare == true) {
            emailTemplate = "live-motor-rideshare-referral-email";
          } else {
            emailTemplate = "live-motor-referred-email";
          }
          customerEmailTemplate = "live-motor-referred-email-to-customer";

          referredReasons = [
            ...this.localReferredReasons,
            ...(this.underwritingMessages || []).filter((message) => {
              return String(message && message.underwritingDecision || "").toUpperCase() !== "DECLINED";
            })
          ];

        }

        if (!status || !emailTemplate) {
          return;
        }

        const modelForEmail = await this.persistMotorUnderwritingInformation(status, declinedReasons, referredReasons);
        await entsiaFunctions.sendPartnerEmail(
          modelForEmail,
          emailTemplate,
          true,
          true,
          customerEmailTemplate
        );
        this.informationSubmitted = true;
        this.step = "outcome";
        this.scrollUp();
      } finally {
        this.isSubmittingInformation = false;
      }
    },
    async persistMotorUnderwritingInformation(status, declinedReasons = [], referredReasons = []) {
      const guid = this.model && this.model.Customer_policy_guid;
      if (!guid) {
        throw new Error("persistMotorUnderwritingInformation: no Customer_policy_guid on model");
      }

      const modelToPersist = this.buildMotorQuoteSnapshotForPersistence();
      modelToPersist.status = status;
      modelToPersist.declinedReasons = declinedReasons;
      modelToPersist.referredReasons = referredReasons;
      await entsiaFunctions.submitMotorUnderwritingInformation(guid, status, modelToPersist);
      this.model = modelToPersist;
      return modelToPersist;
    },
    async persistMotorQuoteStatus(status) {
      const guid = this.model && this.model.Customer_policy_guid;
      if (!guid) {
        console.warn("persistMotorQuoteStatus: no Customer_policy_guid on model");
        return;
      }
      try {
        await entsiaFunctions.updateMotorQuoteStatusByGuid(guid, status);
        this.model.status = status;
      } catch (e) {
        const msg =
          e.response && e.response.data
            ? e.response.data
            : e.message || e;
        console.error("persistMotorQuoteStatus failed:", msg, e.response && e.response.status);
      }
    },
    canRemoveVehicle(row) {
      console.log(this.model.vehicles);
      console.log(row);


      var otherVehicles = this.model.vehicles.filter(f => f.vehicle.isTrailer == row.vehicle.isTrailer);

      console.log(otherVehicles.length);

      return false;
    },
    formatCurrencyString(num) {

      console.log(num);

      return formattingMethods.formatCurrencyString(num);
    },
    formatCurrencyStringNoDecimals(num) {

      console.log(num);

      return formattingMethods.formatCurrencyStringNoDecimals(num);
    },
    getSumInsuredTypeLabel(sumInsuredType) {
      return sumInsuredType === "MARKET" ? "Market Value" : "";
    },
    buildListOfAdditionalGoods() {
      const selected = Array.isArray(this.model && this.model.additionalGoods)
        ? this.model.additionalGoods
        : [];
      const primary = this.model && this.model.primaryGoods;
      return selected
        .filter((code) => code && code !== primary)
        .map((code) => ({
          additionalGood: {
            status: "NEW",
            additionalGoods: code,
          },
        }));
    },
    parseAdditionalGoodsFromEntsia(vehiclesAndGoods) {
      const list =
        vehiclesAndGoods && Array.isArray(vehiclesAndGoods.listOfAdditionalGoods)
          ? vehiclesAndGoods.listOfAdditionalGoods
          : [];
      return list
        .map((item) => item && item.additionalGood && item.additionalGood.additionalGoods)
        .filter(Boolean);
    },
    deleteDangerousGoodsItem(idx) {

    },
    saveDangerousGoodsItem(modifiedItem) {

      if (modifiedItem.editMode == "edit") {


        // modifiedItem.item.claim.dateOfLoss = this.$moment(new Date(modifiedItem.item.claim.dateOfLoss)).format("YYYY-MM-DD");

        // modifiedItem.item.claim.totalIncurred = parseFloat(modifiedItem.item.claim.totalIncurred);

        // this.model.listOfClaims[modifiedItem.selectedItemIndex] = modifiedItem.item;
        // this.model = structuredClone(this.model);
      } else {
        var newDG = structuredClone(modifiedItem.item);

        //newDG.claim.dateOfLoss = this.$moment(new Date(newDG.claim.dateOfLoss)).format("YYYY-MM-DD");

        newDG.dangerousGoods.dangerousGoodsClass = newDG.dangerousGoods.dangerousGoodsClass;
        newDG.dangerousGoods.dangerousGoodsDescription = newDG.dangerousGoods.dangerousGoodsDescription;
        newDG.dangerousGoods.dangerousGoodsQuantity = newDG.dangerousGoods.dangerousGoodsQuantity;

        this.model.listOfDangerousGoods.push(newDG);
        this.model = structuredClone(this.model);
      }

      this.refreshQuote();

    },
    editDangerousGoodsItem(_rowData) {



    },
    editPastClaim(_rowData) {

    },
    deletePastClaim(idx) {
      this.model.listOfClaims.splice(idx, 1);

      this.model = structuredClone(this.model);
    },
    editVehicle(_row, idx) {

      this.vehicleEditMode = "edit";

      this.selectedItem = structuredClone(_row);
      this.selectedItemIndex = idx;

      this.$refs['vehicleModal'].openVehicleModal(this.vehicleEditMode, this.selectedItem, this.selectedItemIndex);
    },
    saveClaim(modifiedItem) {
      console.log(modifiedItem);


      if (modifiedItem.editMode == "edit") {
        //this.model.vehicles[this.selectedItemIndex] = modifiedItem;
        //this.model = structuredClone(this.model);

        modifiedItem.item.claim.dateOfLoss = this.$moment(new Date(modifiedItem.item.claim.dateOfLoss)).format("YYYY-MM-DD");

        modifiedItem.item.claim.totalIncurred = parseFloat(modifiedItem.item.claim.totalIncurred);

        this.model.listOfClaims[modifiedItem.selectedItemIndex] = modifiedItem.item;
        this.model = structuredClone(this.model);
      } else {
        var newClaim = structuredClone(modifiedItem.item);

        newClaim.claim.dateOfLoss = this.$moment(new Date(newClaim.claim.dateOfLoss)).format("YYYY-MM-DD");
        newClaim.claim.totalIncurred = parseFloat(newClaim.claim.totalIncurred);

        this.model.listOfClaims.push(newClaim);
        this.model = structuredClone(this.model);
      }

      this.syncLocalReferralFromUsageQuestions();
    },
    saveVehicle(modifiedItem) {

      console.log(modifiedItem);

      var state = this.getAustralianStateFromPostcode(modifiedItem.vehicle.vehiclePostcode);

      modifiedItem.vehicle.vehicleState = state;


      if (this.vehicleEditMode == "edit") {
        this.model.vehicles[this.selectedItemIndex] = modifiedItem;
        this.model = structuredClone(this.model);
      } else {
        this.model.vehicles.push(structuredClone(modifiedItem));
        this.model = structuredClone(this.model);
      }

      this.refreshQuote();

      this.quoteChanged();

    },
    addVehicle() {

      this.vehicleEditMode = "add";

      this.selectedItem = {
        "vehicle": {
          "vehicleLabel": "",
          "vehicleLabelPrint": "",
          "coverType": "COMP",
          "vehicleType": "",
          "vehicleClass": "",
          "motorwebGlasses": {
            "nvic": "",
            "registration": "",
            "state": "",
            "vin": "",
            "year": "",
            "make": "",
            "family": "",
            "variant": "",
            "style": "",
            "transmission": "",
            "engine": "",
            "resultGlasses": "",
            "segment": "",
            "newVehicleValue": 0,
            "grossMass": "0",
            "searchType": "CANT_FIND_MOTORWEB",
            "upperMarket": 0,
            "vehicleCategory": "PV",
            "searchTypeFilter": "BUS"
          },
          "freightTask": "",
          "operatingRadius": "2",
          "sumInsuredType": "MARKET",
          "sumInsured": 0,
          "basicExcess": 500,
          "ncb": "0",
          "vehiclePostcode": "",
          "vehicleState": "",
          "dangerousGoodsLimit": "",
          "hireVehicle": "NO",
          "agreedValueUpper": 0,
          "vehicleYear": "",
          "isDangerousAndHazardousGoods": "",
          "isTrailer": "",
          "sumInsuredDisplayValue": "",
          "ownDamageFilter": "NO",
          "isDowntime": "NO",
          "isTruck": "NO",
          "originalSumInsured": 0,
          "vehicleDefaultRadius": "AUSWIDE",
          "ncbEditable": "YES",
          "vehicleDowntimeRequired": "NO",
          "hookLiability": "NO",
          "noAccessories": "YES",
          "accessories": "",
          "accessoriesSumInsured": ""
        }
      };



      this.$refs['vehicleModal'].openVehicleModal(this.vehicleEditMode, this.selectedItem, 0);
    },
    removeVehicle(idx) {

      this.model.vehicles.splice(idx, 1);

      this.model = structuredClone(this.model);

    },
    sendRideShareReferralEmail() {

    },
    onRideShareChange() {
      if (this.model.vehicleRideShare == true) {
        this.$refs['rideshareModal'].openModal();
      }
      this.updateForm();
    },
    syncLocalReferralFromUsageQuestions() {
      const hasLocalReferral =
        this.model.vehicleRideShare == true ||
        this.model.vehicleUsageSpecialFitOut == true ||
        this.model.atFault == true ||
        this.model.claimLodged == true;

      if (hasLocalReferral) {
        this.hasbeenReferred = true;
      } else if (!(this.underwritingMessages && this.underwritingMessages.length)) {
        this.hasbeenReferred = false;
      }
    },
    async updateForm() {
      //console.log("firing");
      console.log(this.model.vehicleUsageSpecialFitOut);

      if (this.model.atFault == true || this.model.claimLodged == true) {
        this.model.priorClaims = true;
      } else {
        this.model.priorClaims = false;
      }

      this.syncLocalReferralFromUsageQuestions();

      if (this.model != null) {
        this.model = structuredClone(this.model);
      }

      this.$nextTick(() => {
        if (
          this.model.priorClaims == true &&
          (!this.model.listOfClaims || this.model.listOfClaims.length == 0) &&
          this.$refs.pastClaimsList
        ) {
          this.$refs.pastClaimsList.addClaim();
        }
      });
    },
    quoteChanged() {
      this.quoteModified = true;
    },
    modifyNCB(model) {

      //       { "value": "0", label: "Nil - No prior insurance or NCB reduced due to claims" },
      // { "value": "20", label: "20% - 1 year claims free" },
      // { "value": "30", label: "30% - 2 years claims free" },
      // { "value": "40", label: "40% - 3 years claims free" },
      // { "value": "50", label: "50% - 4 years claims free" },

      var adjustedNCB = "0";

      console.log(model.Data_obj.messageData.policy.commercialMotorSubproduct.generalMotorDetails.yearsOfOperation);

      if (this.model.lengthOfOperating == "1") {
        adjustedNCB = "0";
      }

      if (this.model.lengthOfOperating == "2") {
        adjustedNCB = "20";
      }

      if (this.model.lengthOfOperating == "3") {
        adjustedNCB = "30";
      }

      // if (this.model.lengthOfOperating == "4") {
      //   adjustedNCB = "50";
      // }

      if (parseInt(this.model.lengthOfOperating) > 3) {
        adjustedNCB = "50";
      }


      for (var vehicle of model.vehicles) {
        vehicle.vehicle.ncb = adjustedNCB;
      }

      return model;

    },
    async refreshQuote() {


      var currentDate = this.$moment(new Date()).add(0, 'days').format("YYYY-MM-DD");
      var endDate = this.$moment(new Date()).add(0, 'years').format("YYYY-MM-DD");

      this.model.Data_obj.messageData.policy.inceptionDate = currentDate;

      this.model.Data_obj.messageData.policy.termStartDate = currentDate;
      this.model.Data_obj.messageData.policy.termEndDate = endDate;


      this.model.Data_obj.messageData.policy.effectiveDate = currentDate;

      //"termStartDate": currentDate,

      //this.model = this.modifyNCB(this.model);

      var modelToSend = structuredClone(this.model);


      for (var vehicle of modelToSend.vehicles) {
        vehicle.vehicle.sumInsured = parseFloat(vehicle.vehicle.sumInsured);
        vehicle.vehicle.basicExcess = parseFloat(vehicle.vehicle.basicExcess);
        vehicle.vehicle.makeListNotFound = "YES";
        vehicle.vehicle.manualMake = vehicle.vehicle.motorwebGlasses.make;

      }

      // Keep Entsia payload in sync with UI vehicle edits (e.g. per-vehicle operatingRadius).
      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.listOfVehicles =
        modelToSend.vehicles;

      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.primaryGood = this.model.primaryGoods;
      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.listOfAdditionalGoods = this.buildListOfAdditionalGoods();
      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.currentlyInsured = this.model.currentlyInsured == true ? "YES" : "NO";


      if (this.model.currentlyInsured == false) {
        //modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.uninsuredReason = this.model.reasonsNotInsured || "";
        modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.uninsuredReason = this.model.reasonNotInsured || "1";
        delete modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.previousInsurer;
      }

      if (this.model.currentlyInsured == true) {
        delete modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.uninsuredReason
        modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.vehiclesAndGoods.previousInsurer = this.model.currentInsurer;
      }

      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.generalMotorDetails.nswSdExemption = this.model.nswSdExemption == true ? "YES" : "NO";

      if (this.model.nswSdExemption == true) {
        modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.generalMotorDetails.nswSdExemptionDeclaration = "YES";
      }

      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.generalMotorDetails.yearsOfOperation = this.model.lengthOfOperating;

      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.generalMotorDetails.radiusOfOperation = this.model.radiusOfOperation;

      console.log(modelToSend);

      // Keep claim referral answers local on customerPolicy — do not send them to Entsia
      // (Entsia returns validation/referral messages for these and we handle referral ourselves).
      modelToSend.Data_obj.messageData.policy.sharedPolicySubproduct.disclosureDetails.listOfClaims = [];
      modelToSend.Data_obj.messageData.policy.sharedPolicySubproduct.disclosureDetails.priorClaims = "NO";
      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.motorDisclosure.atFault = "NO";
      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.motorDisclosure.claimLodged = "NO";

      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.dangerousGoodsDisclosure.bulkDangerousGoodsCarried = this.model.dangerousGoods1 ? "YES" : "NO";


      modelToSend.Data_obj.messageData.policy.commercialMotorSubproduct.dangerousGoodsDisclosure.listOfDangerousGoods = this.model.listOfDangerousGoods;


      //console.log(modelToSend);



      this.isLoading = true;


      var yihqData = {
        "quoteId": modelToSend.quoteId,
        "brokerId": modelToSend.Broker_id,
        "customFields": {
          "customerId": modelToSend.Customer_id,
        }
      }

      modelToSend.Data_obj.messageData.policy.status = "DRAFT";

      var resp = await entsiaFunctions.updateQuote(modelToSend);

      console.log("here");
      console.log(resp);

      var validResponse = true;

      this.isLoading = false;


      if (resp.quoteResp.response && resp.quoteResp.response.errors && resp.quoteResp.response.errors.length > 0) {
        this.apiErrors = resp.quoteResp.response.errors;
        validResponse = false;
        //alert("error");
      } else {

        this.apiErrors = [];

        if (resp.quoteResp.messageData.policy.underwritingMessages) {
          this.underwritingMessages = resp.quoteResp.messageData.policy.underwritingMessages;
          validResponse = false;
          this.hasbeenReferred = true;
        } else {
          this.underwritingMessages = [];
        }

        if (resp.quoteResp.messageData.policy.validationMessages) {
          this.validationMessages = resp.quoteResp.messageData.policy.validationMessages;
          validResponse = false;
        } else {
          this.validationMessages = [];
        }

      }

      this.syncLocalReferralFromUsageQuestions();



      if (validResponse == true) {

        //this.model.Data_obj = resp;

        //console.log(resp);

        this.model.Data_obj.totalPremiumIncFees = resp.quoteResp.totalPremiumIncFees;

        this.$refs.formValidator.validate();


      }


    },
    isPage1FormValid() {

      console.log(this.security1_other);

      var isValid = true;

      if (this.checkedVehicleDetails == false) {
        isValid = false;
      }

      if (this.model.businessDesc == "" || this.model.businessDesc == null) {
        isValid = false;
      }

      if (this.model.nswSdExemption == true && this.nswSdExemptionDeclaration == false) {
        isValid = false;
      }

      if (!this.model.financier) {
        isValid = false;
      }

      if (this.model.financier == 'Other' && (!this.model.financierOther || this.model.financierOther == '')) {
        isValid = false;
      }

      /*
    
    
      console.log(this.fileList.length);
      console.log(this.model.descriptionOfAsset);
    
    
      //if (this.fileList.length == 0 && (!this.model.descriptionOfAsset || this.model.descriptionOfAsset == "")) {
      if (!(this.fileList.length > 0 || this.model.descriptionOfAsset != "")) {
        isValid = false;
      }
    
    
    
      if (this.model.Data_obj.totalSumInsured > 125000) {
    
        // if (this.selectedSecurity1.length == 0 || this.selectedSecurity2.length == 0 || this.selectedSecurity4.length == 0) {
        //   return false;
        // }
    
    
        // if (this.security3 == "") {
        //   return false;
        // }
    
        if (this.selectedSecurity1.includes("Other") && this.security1_other == "") {
          return false;
        }
    
        if (this.selectedSecurity2.includes("Other") && this.security2_other == "") {
          return false;
        }
    
        if (this.selectedSecurity4.includes("Other") && this.security4_other == "") {
          return false;
        }
      }
    
      // if (!(this.fileList.length > 0 || this.model.financier)) {
      //   return false;
      // }
    
      if (this.model.financier == 'Other' && (!this.model.financierOther || this.model.financierOther == '')) {
        return false;
      }
    
    
    */


      return isValid;


    },
    async customAction(file) {
      const blob = await fetch(file.blob).then((res) => res.blob());
      const base64data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      await appFunctions.addFinanceFileAttachment({
        Customer_policy_id: this.model.Customer_policy_guid,
        fileContent: base64data,
        filename: file.name,
        guid: GlobalMethods.uuidv4(),
        createdDateTime: new Date(),
        type: "ps-equipment-invoice",
      });

      return null;
    },
    /**
     * Has changed
     * @param  Object newFile Read only
     * @param  Object oldFile Read only
     */
    inputFile: function (newFile, oldFile) {

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log("response", newFile.response);
        if (newFile.xhr) {
          //  Get the response status code
          console.log("status", newFile.xhr.status);
        }
      }

      setTimeout(() => {
        if (
          Boolean(newFile) !== Boolean(oldFile) ||
          oldFile.error !== newFile.error
        ) {
          this.$refs[this.uploaderKey].active = true;
        }
      }, 2000);
    },
    /**
     * Pretreatment
     * @param  Object newFile Read and write
     * @param  Object oldFil  Read only
     * @param  Function prevent Prevent changing
     */
    inputFilter: function (newFile, oldFile, prevent) {
      let pending = (this.fileList || []).some((f) => f !== newFile && !f.success);
      if (newFile && !newFile.success) {
        pending = true;
      }
      this.$emit("disableNextStep", pending);

      if (newFile && !oldFile) {
        // Filter non-image file
        if (
          !/\.(jpeg|jpe|jpg|gif|png|webp|doc|docx|pdf|xls|xlsx|csv)$/i.test(
            newFile.name
          )
        ) {
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },
    async acceptQuote() {
      if (this.isAcceptingQuote) {
        return;
      }
      this.isAcceptingQuote = true;
      console.log(this.model);

      var _modelToSend = this.model;

      console.log(_modelToSend);

      const rawFinancier =
        this.model.financier != null && String(this.model.financier).trim() !== ""
          ? this.model.financier
          : this.model.Customer_policy_Broker_finance_financier;
      const rawFinancierOther =
        this.model.financierOther != null && String(this.model.financierOther).trim() !== ""
          ? this.model.financierOther
          : this.model.Customer_policy_Broker_finance_financier_other;
      const financierOtherTrimmed = (rawFinancierOther || "").trim();
      const rawFinancierTrimmed =
        rawFinancier != null ? String(rawFinancier).trim() : "";
      // "Don't know" satisfies UI selection but must not be sent as an Entsia interested party
      const isUnknownFinancier =
        !rawFinancierTrimmed ||
        rawFinancierTrimmed.toLowerCase() === "don't know" ||
        rawFinancierTrimmed.toLowerCase() === "dont know";

      let financierName = "";
      if (!isUnknownFinancier) {
        if (rawFinancierTrimmed === "Other") {
          financierName = financierOtherTrimmed;
        } else {
          financierName = rawFinancierTrimmed;
        }
      }

      if (financierName) {
        const pol = _modelToSend.Data_obj.messageData.policy;
        if (!pol.sharedPolicySubproduct) {
          this.$set(pol, "sharedPolicySubproduct", {});
        }
        const financierInterestedParty = {
          //"reference": "9b47a6ca-d192-40f8-8326-019b807663d1",
          nameOfInterestedParty: financierName,
          address: {
            //"reference": "17b5a4a1-5586-443f-af44-57a4515a77af",
            manualInput: "YES",
          },
          relatedInterest: "TRANS_OTHER",
          relatedInterestOtherDescription: "Financier",
        };
        const financierSlaveVehicle = [
          {
            interestedPartyContainer: {
              interestedParty: { ...financierInterestedParty },
            },
          },
        ];

        pol.sharedPolicySubproduct.policyInterestedParty = {
          //"reference": "d6288e04-432c-43a9-b294-a94ae3a0b972",
          status: "NEW",
          interestedPartySlavePolicy: [
            {
              interestedPartyContainer: {
                //"reference": "7be3ef58-47d0-410a-bd22-b6f8f7f96c3a",
                interestedParty: { ...financierInterestedParty },
              },
            },
          ],
          interestedPartyMasterList: [
            {
              interestedPartyDetail: { ...financierInterestedParty },
            },
          ],
        };

        // Also link financier at vehicle level — Combined CoC may only print vehicle IPs
        const listOfVehicles =
          pol.commercialMotorSubproduct &&
          pol.commercialMotorSubproduct.vehiclesAndGoods &&
          pol.commercialMotorSubproduct.vehiclesAndGoods.listOfVehicles;
        if (Array.isArray(listOfVehicles)) {
          for (const item of listOfVehicles) {
            if (!item || !item.vehicle) {
              continue;
            }
            this.$set(
              item.vehicle,
              "interestedPartySlaveVehicle",
              JSON.parse(JSON.stringify(financierSlaveVehicle))
            );
          }
        }
        if (Array.isArray(_modelToSend.vehicles)) {
          for (const item of _modelToSend.vehicles) {
            if (!item || !item.vehicle) {
              continue;
            }
            this.$set(
              item.vehicle,
              "interestedPartySlaveVehicle",
              JSON.parse(JSON.stringify(financierSlaveVehicle))
            );
          }
        }

        _modelToSend.financier = rawFinancier;
        _modelToSend.financierOther =
          rawFinancierTrimmed === "Other" ? financierOtherTrimmed : "";
      } else if (isUnknownFinancier) {
        // Keep form value for YIHQ persistence if needed, but no Entsia IP payload
        _modelToSend.financier = rawFinancierTrimmed || "Don't know";
        _modelToSend.financierOther = "";
      }

      // _modelToSend.security1 = this.selectedSecurity1.toString();

      // if (this.selectedSecurity1.includes("Other") && this.security1_other) {
      //   _modelToSend.security1 = _modelToSend.security1 + "," + this.security1_other
      // }

      // _modelToSend.security2 = this.selectedSecurity2.toString();

      // if (this.selectedSecurity2.includes("Other") && this.security2_other) {
      //   _modelToSend.security2 = _modelToSend.security2 + "," + this.security2_other
      // }

      // _modelToSend.security3 = this.security3;

      // _modelToSend.security4 = this.selectedSecurity4.toString();

      // if (this.selectedSecurity4.includes("Other") && this.security4_other) {
      //   _modelToSend.security4 = _modelToSend.security4 + "," + this.security4_other
      // }


      //console.log(_modelToSend);

      try {
        await protecsureFunctions.acceptMotorQuote(_modelToSend)
          .then(async (resp) => {
            console.log(resp);

            await this.persistMotorQuoteStatus(motorQuoteStatus.policyBound);
            this.step = "accepted";
            //this.customerList = resp.data.filter(data => data && data.Customer_insured_name)
          });
      } finally {
        this.isAcceptingQuote = false;
      }



      //this.model.acceptDOD = this.
    },
    confirm(_step) {
      this.scrollUp();

      this.step = _step;

      setTimeout(() => {
        this.$refs.formValidator.validate();
      }, 500);
    },
    getDisabledFields(mode) {
      var retObj = {};
      if (mode == "edit" || mode == "create") {
        retObj = {
          policyStart: false,
          insuredName: false,
          insuredABN: false,
          businessDesc: false,
          businessActivity: false,
          contactFName: false,
          contactLName: false,
          contactEmail: false,
          contactPhone: false,
          insuredAddress: false,
          insuredStreet: false,
          insuredCity: false,
          insuredState: false,
          insuredPostcode: false,
          businessAddress: false,
          businessStreet: false,
          businessCity: true,
          businessState: true,
          businessPostcode: true,
          associatedEntities: false,
          stampDutyStatus: false,
          tradingTime: false,
          otherTradingNames: false,

          equipmentDescription: false,
          equipmentValue: false,
          equipmentCondition: false,
          operatingArea: false,
          usedOnPublicRoad: false,
          //insurancePeriod: "12 Months",
          financier: false,
          Quote_Ref_No: true,
          registeredForGst: true,
          claims3Years: true,
          anyExpensiveItems: true
        };
      } else {
        retObj = {
          policyStart: true,
          insuredName: true,
          insuredABN: true,
          businessDesc: true,
          businessActivity: true,
          contactFName: true,
          contactLName: true,
          contactEmail: true,
          contactPhone: true,
          insuredAddress: true,
          insuredStreet: true,
          insuredCity: true,
          insuredState: true,
          insuredPostcode: true,
          businessAddress: true,
          businessStreet: true,
          businessCity: true,
          businessState: true,
          businessPostcode: true,
          associatedEntities: true,
          stampDutyStatus: true,
          tradingTime: true,
          otherTradingNames: true,

          equipmentDescription: true,
          equipmentValue: true,
          equipmentCondition: true,
          operatingArea: true,
          usedOnPublicRoad: true,
          //insurancePeriod: "12 Months",
          financier: true,
          Quote_Ref_No: true,
          registeredForGst: true,
          claims3Years: true,
          anyExpensiveItems: true
        };
      }
      return retObj;
    },

    selectExcess(item, option) {

      item.selectedExcess = item.value;
      item.selectedExcessId = item.id;


      var itemToUpdate = this.selectEquipmentItems.find(f => f.categoryItemId == option.categoryItemId)
      console.log(itemToUpdate);


      itemToUpdate.selectedExcess = item.value;
      itemToUpdate.selectedExcessId = item.id;


      console.log(item);
      console.log(option);
    },
    toggleEquipmentItem(eqItem) {


      var findEI = this.selectEquipmentItems.find(f => f.categoryItemId == eqItem.categoryItemId);

      if (!findEI) {

        console.log(eqItem);

        var minExcess = 0;
        var minExcessId = 0;

        var excessOptions = this.formInitData.equipmentExcesses.map(m => {
          var enabled = false;

          if (m.excessValue >= eqItem.minimumExcessAllowed) {
            enabled = true;
            minExcess = m.excessValue;
            minExcessId = m.excessId;
          }
          return {
            label: "$" + m.excessValue,
            value: m.excessValue,
            id: m.excessId,
            enabled: enabled,
            selected: false
          }

        });



        this.selectEquipmentItems.push({
          categoryItemId: eqItem.categoryItemId,
          categoryName: eqItem.categoryName,
          excessOptions: excessOptions,
          //selectedExcess: minExcess,
          //selectedExcessId: minExcessId,
          selectedExcess: 0,
          selectedExcessId: 0,
          insuredAmount: 0
          // {
          //   label: "$100",
          //   value: 100,
          //   enabled: false
          // },
          // {
          //   label: "$250",
          //   value: 250,
          //   enabled: true
          // },
          // {
          //   label: "$500",
          //   value: 500,
          //   enabled: true
          // },
          // {
          //   label: "$1000",
          //   value: 1000,
          //   enabled: true
          // }

        })

        //.map((m) => { return { ...m, ...{ selectedExcess: 0, insuredAmount: 0 } } })


      } else {
        this.selectEquipmentItems = this.selectEquipmentItems.filter(f => f.categoryItemId != eqItem.categoryItemId);
      }



    },
    selectCustomer(e) {
      this.selected = true
      const findCustomer = this.customerList.find(f => f.Customer_id == e);
      this.enteredInsuredName = findCustomer ? findCustomer.Customer_insured_name : this.enteredInsuredName
      if (findCustomer) {
        this.formData(findCustomer, true)
      } else {
        this.formData(null, false)
      }
    },
    formData(data, disabled) {
      this.model.insuredName = data ? data.Customer_insured_name : this.enteredInsuredName
      this.model.businessDesc = data ? data.Customer_business_description : ""
      this.model.contactEmail = data ? data.Customer_contact_email : ""
      this.model.contactPhone = data ? data.Customer_contact_number : ""
      this.model.insuredStreet = data ? data.Customer_contact_street : ""
      this.model.insuredCity = data ? data.Customer_contact_city : ""
      this.model.insuredState = data ? data.Customer_state : ""
      this.model.insuredPostcode = data ? data.Customer_postcode : ""
      this.model.insuredABN = data ? data.Customer_abn : ""
      this.model.contactFName = data ? data.Customer_contact_first_name : ""
      this.model.contactLName = data ? data.Customer_contact_last_name : ""
      this.model.selectedCustomerId = data ? data.Customer_id : ""
      this.model.Ubind_customer_id = data ? data.Ubind_customer_id : ""
      this.fieldsDisabled.insuredName = disabled
      this.fieldsDisabled.businessDesc = disabled
      this.fieldsDisabled.contactEmail = disabled
      this.fieldsDisabled.contactPhone = disabled
      this.fieldsDisabled.insuredStreet = disabled
      this.fieldsDisabled.insuredCity = disabled
      this.fieldsDisabled.insuredState = disabled
      this.fieldsDisabled.insuredPostcode = disabled
      this.fieldsDisabled.insuredABN = disabled
      this.fieldsDisabled.contactFName = disabled
      this.fieldsDisabled.contactLName = disabled

      this.fieldsDisabled.Quote_Ref_No = disabled

    },
    InsuredNameBlurred(e) {
      this.model.insuredName = this.enteredInsuredName;
    },
    setInsuredName(e) {
      this.enteredInsuredName = e.target.value;
    },
    visibleChange(e) {

      console.log("fired");

      if (e) {
        this.selected = false
      }
      if (!e && !this.selected) {
        this.model.insuredName = this.enteredInsuredName;
        this.enteredInsuredName && this.formData(null, false)
      }
    },
    copyAddress() {

      console.log(this.model);

      this.model.situationStreet = this.model.Customer_contact_street;
      this.model.situationCity = this.model.Customer_contact_city;
      this.model.situationState = this.model.Customer_state;
      this.model.situationPostcode = this.model.Customer_postcode;

      this.model = { ...this.model };
    },
    scrollUp() {
      //location.hash = "#calcSection";
      const myEl = this.$refs.topSection;

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#topSection" // required if updateHistory is true
      });
    },
    scrollDown() {
      //location.hash = "#calcSection";
      const myEl = this.$refs.calcSection;

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#calcSection" // required if updateHistory is true
      });
    },
    scrollToPaymentTerms() {
      const myEl = this.$refs.paymentTermsSection;
      if (!myEl) {
        return;
      }

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#paymentTermsSection",
      });
    },
    applyCloudfloatRetryFlow() {
      if (!this.isCloudfloatRetryFlow) {
        return;
      }

      // Vehicle confirmation is required to leave page 1; auto-confirm for retry
      // so the user can land directly on payment terms (annual only).
      this.checkedVehicleDetails = true;
      this.paymentTerm = "annual";
      this.step = "step3";

      // Bind button requires these three acknowledgements.
      this.$set(this.model, "agreeAdviceDisclosure", true);
      this.$set(this.model, "agree", true);
      this.$set(this.model, "acceptDOD", true);

      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToPaymentTerms();
        }, 300);
      });
    },
    async createNewQuote() {

      var quoteToSend = {
        "brokerId": "brk-0134",
        "type": "light-machinery",
        "inceptionDate": this.model.policyStart,
        "expiryDate": this.model.expiryDate,
        "periodOfCover": 12,
        "insuredPostcode": this.model.insuredPostcode,
        "insuredState": this.model.insuredState,
        "insuredSuburb": this.model.insuredCity,
        "insuredName": this.model.insuredName,
        "excess": 1000,
        "registeredForGst": this.model.registeredForGST,
        "source": "YIHQ Form",
        "equipmentItems": this.selectEquipmentItems.map(m => {
          return {
            "itemId": m.categoryItemId,
            "specifiedSumInsured": parseFloat(m.insuredAmount),
            "unSpecifiedSumInsured": 0,
            "excessId": m.selectedExcessId
          }
        }),
        "customFields": {
          "customerId": this.model.selectedCustomerId,
          "claimsOrLossesLast3Years": false,
          "moreThan50k": false,
          "isChubbCurrentlyUnderWriting": false
        }
      }



      //       {
      //   "itemId": 266,
      //   "specifiedSumInsured": 15000,
      //   "unSpecifiedSumInsured": 0,
      //   "excessId": 30000
      // }

      // {
      //   "itemId": 266,
      //     "specifiedSumInsured": 12000,
      //       "unSpecifiedSumInsured": 12000,
      //         "excessId": 30000
      // }

      //console.log(this.lse)

      //var findEquipmentCode =


      console.log(this.model);

      console.log(quoteToSend)



      // const isValid = await this.$refs.formValidator.validate();

      // if (!isValid) {
      //   this.$toasted
      //     .error("Please complete the required fields before proceeding.", {
      //       position: "bottom-center"
      //     })
      //     .goAway(4000);
      // } else {
      //   var calcData = quoteFormMethods.getCalculation(this.model);



      //   this.$toasted
      //     .success("Quote Successfully Created", {
      //       position: "bottom-center"
      //     })
      //     .goAway(4000);

      //

      /*
      
            this.isLoading = true;
      
      
      
            protecsureFunctions.requestQuote(quoteToSend).then(resp => {
              console.log(resp);
              this.mode = "view";
      
      
              this.model.Customer_policy_insurance_total_premium =
                resp.totalPremium;
              this.model.Customer_policy_insurance_premium =
                resp.grossBasePremium;
              this.model.Customer_policy_insurance_premium_gst =
                resp.gst;
              this.model.Customer_policy_insurance_premium_stamp_duty =
                resp.stampDuty;
              //this.model.Customer_policy_fee = calcData.Customer_policy_fee;
      
              resp.equipmentExcesses.forEach(item => {
                this.quoteNotes.push(item.description)
              })
      
              resp.equipmentMaxLiability.forEach(item => {
                this.quoteNotes.push(item.description)
              })
      
      
              this.isLoading = false;
      
              this.model.Customer_policy_status = "in_progress";
            })
      
      
      
            //requestQuote
      */


      //console.log(this.selectedCustomerId);

      // var policy_id = await quoteFormMethods.createQuote(
      //   this.model,
      //   this.selectedCustomerId
      // );

      // this.$router.push({
      //   path: "quotes/" + policy_id,
      //   query: { status: "created" }
      // });
      //}
    },
    emailOffer() {
      // quoteFormMethods.changeStatus(
      //   this.policy_id,
      //   "offer_sent_awaiting_information"
      // );

      // GlobalStore.realmApp.functions
      //   .crud_customerPolicy("getCombined", {
      //     policy_id: parseInt(this.policy_id)
      //   })
      //   .then(resp => {
      //     emailMethods.sendOfferEmail(GlobalStore.realmApp, resp.data);
      //     this.$router.push("/quotes/" + this.policy_id + "/offerSent");
      //   });
    },
    goBack(_step) {
      this.step = _step;
      if (_step === "step1") {
        this.$nextTick(() => {
          this.initAddressSearch();
        });
      }
    },
    editQuote() {
      this.formMode = "edit";
      this.scrollUp();
    },
    updateQuote() {
      var calcData = quoteFormMethods.getCalculation(this.model);

      this.model.Customer_policy_insurance_total_premium =
        calcData.Customer_policy_insurance_total_premium;
      this.model.Customer_policy_insurance_premium =
        calcData.Customer_policy_insurance_premium;
      this.model.Customer_policy_insurance_premium_gst =
        calcData.Customer_policy_insurance_premium_gst;
      this.model.Customer_policy_insurance_premium_stamp_duty =
        calcData.Customer_policy_insurance_premium_stamp_duty;
      this.model.Customer_policy_fee = calcData.Customer_policy_fee;

      quoteFormMethods.updateQuote(this.realmApp, this.rawModel, this.model);

      this.scrollDown();

      this.formMode = "view";
    },
    firstFormSubmit() {
      console.log("clicked");
    },
    readFinancier(event) {
      console.log("typed");
      if (event == "Other") {
        this.financierOtherDisabled = false;
        //this.model.financier = "";
      } else {
        this.financierOtherDisabled = true;
        this.model.financierOther = "";
      }
    },
    /**
     * @desc Clears the address city, state and postcode fields when the street
     * field is cleared.
     */
    clearAddressFields() {
      if (this.model.insuredStreet == "") {
        this.model.insuredCity = "";
        this.model.insuredState = "";
        this.model.insuredPostcode = "";
      }
    },
    initAddressSearch() {
      if (!document.getElementById("addrs_1")) {
        return;
      }

      let script = document.createElement("script");
      script.setAttribute(
        "src",
        "https://api.addressfinder.io/assets/v3/widget.js"
      );
      script.setAttribute("async", true);
      script.onload = () => {
        const addressInput = document.getElementById("addrs_1");
        if (!addressInput) {
          return;
        }

        this.widget = new window.AddressFinder.Widget(
          addressInput,
          "NMY9RTVQ3UHADL76FJ8G",
          "AU",
          {
            address_params: {
              gnaf: 1
            }
          }
        );
        this.widget.on("result:select", (fullAddress, metaData) => {
          this.model.insuredAddress = metaData.address_line_1;
          this.model.Customer_contact_street = metaData.address_line_combined;
          this.model.Customer_contact_city = metaData.locality_name;
          this.model.Customer_state = metaData.state_territory;
          this.model.Customer_postcode = metaData.postcode;
        });

        this.widget2 = new window.AddressFinder.Widget(
          document.getElementById("addrs_2"),
          "NMY9RTVQ3UHADL76FJ8G",
          "AU",
          {
            address_params: {
              gnaf: 1
            }
          }
        );


        this.widget2.on("result:select", (fullAddress, metaData) => {

          console.log("HERE!");

          // this.model.situationStreet = this.model.Customer_contact_street;
          //       this.model.situationCity = this.model.Customer_contact_city;
          //       this.model.situationState = this.model.Customer_state;
          //       this.model.situationPostcode = this.model.Customer_postcode;

          //this.model.situationAddress = metaData.address_line_1;
          this.model.situationStreet = metaData.address_line_combined;
          this.model.situationCity = metaData.locality_name;
          this.model.situationState = metaData.state_territory;
          this.model.situationPostcode = metaData.postcode;

          this.model = structuredClone(this.model);
        });
      };
      document.head.appendChild(script);
    }
  },
  async mounted() {

    this.model = this.editModel;

    console.log(this.model);

    if (!Array.isArray(this.model.additionalGoods)) {
      this.$set(this.model, "additionalGoods", []);
    }

    if (
      (this.model.financier == null || String(this.model.financier).trim() === "") &&
      this.model.Customer_policy_Broker_finance_financier
    ) {
      this.$set(
        this.model,
        "financier",
        this.model.Customer_policy_Broker_finance_financier
      );
    }
    if (
      (this.model.financierOther == null || String(this.model.financierOther).trim() === "") &&
      this.model.Customer_policy_Broker_finance_financier_other
    ) {
      this.$set(
        this.model,
        "financierOther",
        this.model.Customer_policy_Broker_finance_financier_other
      );
    }

    //priorClaims

    this.model.descriptionOfAsset = "";
    this.model.acceptDOD = null;

    // After acceptDOD reset so retry flow can pre-accept disclosures.
    this.applyCloudfloatRetryFlow();



    //     if (resp.response && resp.response.errors && resp.response.errors.length > 0) {
    //   this.apiErrors = resp.response.errors;
    //   validResponse = false;
    //   //alert("error");
    // } else {

    this.apiErrors = [];

    if (this.model.Data_obj.messageData.policy.underwritingMessages) {
      this.underwritingMessages = this.model.Data_obj.messageData.policy.underwritingMessages;
      this.hasbeenReferred = true;
      //validResponse = false;
    } else {
      this.underwritingMessages = [];

    }

    if (this.model.Data_obj.messageData.policy.validationMessages) {
      this.validationMessages = this.model.Data_obj.messageData.policy.validationMessages;
      //validResponse = false;
    } else {
      this.validationMessages = [];
    }





    // }

    // this.model.security1 = [];

    // this.model.security1_other = "";
    // this.model.security2_other = "";
    // this.model.security4_other = "";



    this.mode = this.formMode;



    //this.isLoading = true;

    console.log(this.model);
    /*
        protecsureFunctions.getFormInitData().then(resp => {
    
          //console.log(resp);
    
          this.formInitData = resp;
    
          console.log(resp);
    
          var eqItem = resp.equipmentCategories.find(f => f.categoryItemId == this.model.Quote_data.equipmentItems[0].itemId);
    
          console.log(eqItem);
    
          //.filter(f => f.excessValue >= eqItem.minimumExcessAllowed)
    
          this.excessOptions = resp.equipmentExcesses.filter(f => f.excessValue >= eqItem.minimumExcessAllowed).map(m => {
            var enabled = false;
    
    
            //if (m.excessValue >= eqItem.minimumExcessAllowed) {
            //enabled = true;
            //minExcess = m.excessValue;
            //minExcessId = m.excessId;
            //}
            return {
              label: m.excessValue,
              value: m.excessValue,
              //enabled: enabled,
              //selected: false
            }
            //} else {
            return null
            //}
    
          });
    
    
          console.log(this.excessOptions);
          this.isLoading = false;
        });
        */

    //this.$refs.formValidator.validate();

    //const _isValid = 
    setTimeout(() => {
      // Address fields only exist on step1; skip when retry lands on payment terms.
      if (this.step === "step1") {
        this.initAddressSearch();
      }
      if (this.$refs.formValidator) {
        this.$refs.formValidator.validate();
      }
    }, 2000);

    // this.isLoading = true;

    //this.model.totalSumInsured

    // await appFunctions.crud_customerLCPolicy("getCombinedByRealmId", {
    //   Realm_user_id: GlobalStore.brokerObj.Realm_user_id
    // })
    //   .then(resp => {
    //     this.customerList = resp.data.filter(data => data && data.Customer_insured_name)
    //   });


    // this.fieldsDisabled.businessDesc = false;
    // this.fieldsDisabled.contactEmail = false;
    // this.fieldsDisabled.contactPhone = false;
    // this.fieldsDisabled.insuredStreet = false;
    // this.fieldsDisabled.insuredCity = false;
    // this.fieldsDisabled.insuredState = false;
    // this.fieldsDisabled.insuredPostcode = false;
    // //this.fieldsDisabled.insuredName = true;
    // this.fieldsDisabled.insuredABN = false;
    // this.fieldsDisabled.contactFName = false;
    // this.fieldsDisabled.contactLName = false;

    // this.fieldsDisabled.policyStart = false;
    // this.fieldsDisabled.expiryDate = false;

    // this.fieldsDisabled.insuredName = false;



    // protecsureFunctions.getFormInitData().then(resp => {
    //   console.log(resp);

    //   this.formInitData = resp;

    //   this.model.policyStart = resp.periodOfCover[0].inceptionDate;
    //   this.model.expiryDate = resp.periodOfCover[0].expiryDate;

    //   this.model.registeredForGST = true;

    //   this.model.claimsOrLossesLast3Years = false;
    //   this.model.moreThan50k = false;



    //   this.isLoading = false;

    // });





    // this.formMode = this.mode;
    // this.realmApp = GlobalStore.realmApp;

    // this.policy_id = this.$route.params.id;

    // this.selectedCustomerId = 0;

    // //changeStatus();

    // let script = document.createElement("script");
    // script.setAttribute(
    //   "src",
    //   "https://api.addressfinder.io/assets/v3/widget.js"
    // );
    // script.setAttribute("async", true);
    // script.onload = () => {
    //   this.widget = new window.AddressFinder.Widget(
    //     document.getElementById("addrs_1"),
    //     "NMY9RTVQ3UHADL76FJ8G",
    //     "AU",
    //     {
    //       address_params: {
    //         gnaf: 1
    //       }
    //     }
    //   );
    //   this.widget.on("result:select", (fullAddress, metaData) => {
    //     this.model.insuredAddress = metaData.address_line_1;
    //     this.model.insuredStreet = metaData.address_line_1;
    //     this.model.insuredCity = metaData.locality_name;
    //     this.model.insuredState = metaData.state_territory;
    //     this.model.insuredPostcode = metaData.postcode;
    //   });
    // };
    // document.head.appendChild(script);

    // console.log(this.$route.params.status);

    // if (this.$route.query.status) {
    //   this.scrollDown();
    // }
    //this.mode = "view";

    //this.model.Customer_policy_status = "in_progress";
  },
  components: {
    BaseInput,
    ButtonRadioGroup,
    [Select.name]: Select,
    [Option.name]: Option,
    Spinner,
    FileUpload,
    VueMultiselectComponent,
    VehicleModal,
    PastClaimsList,
    RideshareModal,
    DangerousGoodsList
  },
  directives: {
    /**
     * Used ensure the keyboard is shown on mobile devices when clicking on an el-select.
     * This is because element-ui was not designed for mobile:
     * https://github.com/ElemeFE/element/issues/12742#issuecomment-420866658
     */
    cancelReadOnly(el) {
      const input = el.querySelector(".el-input__inner");
      input.removeAttribute("readonly");
    }
  }
};
</script>
<style>
.vue2-value-item {
  margin-left: 10px !important;


}

.vue2-value-item-text {
  min-width: 100px;
  padding-left: 10px;
}

.abn-link {
  font-size: 9pt;
  color: var(--uBind) !important;
  position: absolute;
  right: 0px;
  margin-right: 10px;
}

.eq-selected {
  border: 2px black solid !important;
}

.infoText {
  font-size: 0.875rem;
  margin-bottom: 20px;
}

.answerText {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 30px;
}

.duty-disclosure-required-panel {
  border: 4px solid red;
  border-radius: 8px;
  padding: 12px 24px 4px 12px;
}

.duty-disclosure-required-panel .form-group {
  margin-bottom: 0;
}

.duty-disclosure-select {
  margin-right: 16px;
}

.duty-disclosure-required-panel .invalid-feedback {
  display: block;
  width: calc(100% - 16px);
}

.premiumInvalid {
  color: red;
  text-decoration: line-through;
}

.payment-terms-heading {
  margin-bottom: 8px;
}

.payment-terms-helper {
  margin-bottom: 32px;
}

/* Beats .uBind .row div:first-child { padding-left: 0 } from card styles */
.uBind .row div.payment-terms-retry-notice:first-child {
  max-width: 980px;
  margin: 0 auto 24px;
  padding: 16px 24px;
  box-sizing: border-box;
  border: 1px solid #f0c36d;
  border-radius: 8px;
  background: #fff8e8;
  color: #5c4a1f;
  text-align: left;
  line-height: 1.5;
}

.payment-terms-panel {
  border: 1px solid var(--uBind);
  border-radius: 10px;
  margin: 62px auto 30px;
  max-width: 980px;
  min-height: 260px;
  padding: 48px 48px 40px;
  position: relative;
}

.cloudfloat-logo {
  display: block;
  height: auto;
  margin: 0 auto;
  max-width: 180px;
  width: 100%;
}

.cloudfloat-quote {
  margin: 0 auto;
  max-width: 560px;
  padding: 8px 16px 16px;
}

.cloudfloat-brand {
  margin-bottom: 28px;
  text-align: center;
}

.cloudfloat-powered-by {
  color: #8a94a6;
  font-size: 11pt;
  font-weight: 400;
  margin-bottom: 8px;
}

.cloudfloat-card {
  background: #fff;
  margin-bottom: 28px;
  padding: 40px;
}

.cloudfloat-divider {
  border-top: 1px solid #e4e7eb;
  margin: 18px 0;
}

.cloudfloat-summary-row {
  align-items: center;
  color: #1f2937;
  display: flex;
  font-size: 12pt;
  justify-content: space-between;
}

.cloudfloat-summary-row span {
  padding-right: 20px;
}

.cloudfloat-summary-row strong {
  font-size: 12pt;
  font-weight: 500;
  white-space: nowrap;
}

.cloudfloat-summary-row--total {
  margin-top: 14px;
}

.cloudfloat-schedule {
  padding: 4px 0;
}

.cloudfloat-schedule-item {
  align-items: flex-start;
  display: flex;
  gap: 16px;
}

.cloudfloat-schedule-track {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 34px;
}

.cloudfloat-step {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 11pt;
  font-weight: 600;
  height: 34px;
  justify-content: center;
  line-height: 1;
  width: 34px;
}

.cloudfloat-step--active {
  background: #111;
  color: #fff;
}

.cloudfloat-step--final {
  background: #eef1f4;
  color: #667085;
}

.cloudfloat-step-line {
  background: #d0d5dd;
  flex: 1;
  margin: 6px 0;
  width: 2px;
}

.cloudfloat-step-dots {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 34px;
  justify-content: center;
}

.cloudfloat-step-dots span {
  background: #98a2b3;
  border-radius: 50%;
  display: block;
  height: 4px;
  width: 4px;
}

.cloudfloat-schedule-content {
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: space-between;
  min-height: 34px;
  padding-bottom: 18px;
  padding-top: 0;
}

.cloudfloat-schedule-item--last .cloudfloat-schedule-content {
  padding-bottom: 0;
}

.cloudfloat-schedule-label {
  color: #344054;
  font-size: 12pt;
  font-weight: 400;
}

.cloudfloat-schedule-amount {
  color: #111;
  font-size: 12pt;
  font-weight: 500;
  white-space: nowrap;
}

.cloudfloat-cta-button {
  background: #ff5a44 !important;
  border: none !important;
  border-radius: 999px !important;
  box-shadow: none !important;
  display: block;
  font-size: 12pt;
  font-weight: 700;
  margin: 0 auto 0;
  max-width: 560px;
  padding: 14px 28px !important;
  width: 100%;
}

.cloudfloat-cta-button:hover,
.cloudfloat-cta-button:focus,
.cloudfloat-cta-button:active {
  background: #e84d38 !important;
}

.cloudfloat-loading-inline {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 140px;
  padding: 10px 20px 20px;
}

.cloudfloat-orbit-spinner,
.cloudfloat-orbit-spinner * {
  box-sizing: border-box;
}

.cloudfloat-orbit-spinner {
  height: 55px;
  margin: 0 auto 16px;
  perspective: 800px;
  position: relative;
  width: 55px;
}

.cloudfloat-orbit-spinner .orbit {
  border-radius: 50%;
  box-sizing: border-box;
  height: 100%;
  position: absolute;
  width: 100%;
}

.cloudfloat-orbit-spinner .orbit:nth-child(1) {
  animation: cloudfloat-orbit-one 1200ms linear infinite;
  border-bottom: 3px solid var(--uBind);
  left: 0;
  top: 0;
}

.cloudfloat-orbit-spinner .orbit:nth-child(2) {
  animation: cloudfloat-orbit-two 1200ms linear infinite;
  border-right: 3px solid var(--uBind);
  right: 0;
  top: 0;
}

.cloudfloat-orbit-spinner .orbit:nth-child(3) {
  animation: cloudfloat-orbit-three 1200ms linear infinite;
  border-top: 3px solid var(--uBind);
  bottom: 0;
  right: 0;
}

@keyframes cloudfloat-orbit-one {
  0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
  }

  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
  }
}

@keyframes cloudfloat-orbit-two {
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
  }

  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
  }
}

@keyframes cloudfloat-orbit-three {
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
  }

  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
  }
}

.payment-terms-load-error {
  color: #cc1a1a;
  font-weight: 600;
  margin: 40px auto;
  max-width: 520px;
  text-align: center;
}

.payment-terms-toggle {
  background-color: white;
  left: 50%;
  padding: 0 4px;
  position: absolute;
  top: -24px;
  transform: translateX(-50%);
  z-index: 1;
  height: 0px;
}

.payment-terms-toggle.btn-group-toggle {
  display: inline-flex !important;
  flex-direction: row;
  white-space: nowrap;
}

.payment-term-button {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 14pt;
  font-weight: 700;
  justify-content: center;
  min-height: 43px;
  min-width: 310px;
  padding: 0 28px;
}

.payment-terms-placeholder {
  text-align: center;
  color: #111;
  font-size: 12pt;
  font-weight: 300;
  line-height: 1.35;
  margin: auto;
  padding-bottom: 20px;
  width: 100%;
  max-width: 700px;

}

.payment-terms-loading-text {
  color: var(--uBind);
  font-weight: 700;
  margin: 0;
}

.payment-terms-monthly-panel {
  min-height: 180px;
  padding: 12px 8px 8px;
}

.payment-terms-actions,
.payment-terms-referral-submit {
  margin-top: 20px;
}

.vehicleText {
  font-size: 0.8em;
}

.vehicleHeaderText {
  font-size: 0.9em;
}

.vehicle-details-hint {
  font-size: 9pt;
  font-weight: bold;
  color: red;
  line-height: 1.45;
  max-width: 100%;
}

.primary-goods-hint {
  font-size: 0.8rem;
  color: #cc1a1a;
  margin-top: -0.5rem;
  margin-bottom: 0.75rem;
}

.vehicle-details-hint-icon {
  height: 14px;
  width: auto;
  vertical-align: -2px;
  margin: 0 3px;
  display: inline-block;
}

.vehicle-details-confirm-col {
  display: flex;
  justify-content: flex-end;
}

.vehicle-details-confirm {
  border: 2px solid red;
  border-radius: 8px;
  width: 100%;
  max-width: 640px;
  min-height: 48px;
  padding: 14px 18px 14px 28px !important;
  box-sizing: border-box;
}

.vehicle-details-confirm .form-group {
  margin-bottom: 0;
  padding-left: 0;
}

.vehicle-details-confirm-check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  font-size: 0.875rem;
  color: #525f7f;
  line-height: 1.4;
}

.vehicle-details-confirm-check input[type="checkbox"] {
  margin: 2px 0 0 0 !important;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.consent-checkbox .custom-control-label {
  color: #32325d;
  cursor: pointer;
  font-weight: 600;
}

.consent-checkbox .custom-control-label::before,
.consent-checkbox .custom-control-label::after {
  transform: scale(1.3);
}

.consent-checkbox .custom-control-label::before {
  background-color: #fff;
  border: 2px solid #000;
}

.consent-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: var(--uBind);
  border-color: var(--uBind);
}

.consent-checkbox .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 3px rgba(82, 95, 127, 0.25);
}

.vehicle-details-confirm .invalid-feedback {
  position: static !important;
  display: block;
  margin-top: 6px;
}

.apiError2 {


  padding: 0px !important;
  position: fixed !important;
  top: 5px !important;
  left: calc(50% - 400px) !important;
  width: 700px;



  background-color: red !important;


  h3 {
    color: white !important;
  }

  h4 {
    color: white !important;
  }
}

.underWritingMessages2 {
  margin-top: 10px;
  background-color: rgba(255, 143, 7, 0.6) !important;
  padding: 0px !important;
  /* position: fixed !important;
  top: 5px !important;
  left: calc(50% - 400px) !important; */
  /* width: 700px; */
  text-shadow: 1px 1px 1px #000000;

  h3 {
    color: white !important;
  }

  h4 {
    color: white !important;
  }
}

.validationMessages {
  background-color: #98b8cf !important;
  padding: 0px !important;

  h3 {
    color: white !important;
  }

  h4 {
    color: white !important;
  }
}

.invalid-feedback-large {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 90%;
  padding-right: 10px;
  color: #fb6340;
}


ul.revert-list li {
  display: list-item;
  text-align: left;
}
</style>
